import { writable, get } from "svelte/store";
import { makeHttpRequest } from "../stores";

function lookupService(value) {
	const lookupStore = writable(value);

	const getStores = async () => {
		//var lookupTypeResponse = await makeHttpRequest(`/api/lookup/stores`);
		//var lookupTypes = JSON.parse(lookupTypeResponse.response);
		var lookupTypes = [
			{
				LookupStoreId: 1,
				StoreName: "ADELAIDE MYER CENTRE SA"
			},
			{
				LookupStoreId: 2,
				StoreName: "AIRLIE BEACH QLD"
			},
			{
				LookupStoreId: 3,
				StoreName: "AIRPORT WEST VIC"
			},
			{
				LookupStoreId: 4,
				StoreName: "AITKENVALE QLD"
			},
			{
				LookupStoreId: 5,
				StoreName: "ALBANY CREEK QLD"
			},
			{
				LookupStoreId: 6,
				StoreName: "ALBANY WA"
			},
			{
				LookupStoreId: 7,
				StoreName: "ALBION PARK RAIL NSW"
			},
			{
				LookupStoreId: 8,
				StoreName: "ALBION QLD"
			},
			{
				LookupStoreId: 9,
				StoreName: "ALBURY EAST NSW"
			},
			{
				LookupStoreId: 10,
				StoreName: "ALBURY NSW"
			},
			{
				LookupStoreId: 11,
				StoreName: "ALDINGA SA"
			},
			{
				LookupStoreId: 12,
				StoreName: "ALICE SPRINGS NT"
			},
			{
				LookupStoreId: 13,
				StoreName: "ALTONA VIC"
			},
			{
				LookupStoreId: 14,
				StoreName: "ANNERLEY QLD"
			},
			{
				LookupStoreId: 15,
				StoreName: "ARANA HILLS QLD"
			},
			{
				LookupStoreId: 16,
				StoreName: "ARARAT VIC"
			},
			{
				LookupStoreId: 17,
				StoreName: "ARMADALE WA"
			},
			{
				LookupStoreId: 18,
				StoreName: "ARMIDALE NSW"
			},
			{
				LookupStoreId: 19,
				StoreName: "ARNDALE SA"
			},
			{
				LookupStoreId: 20,
				StoreName: "ARNDELL PARK NSW"
			},
			{
				LookupStoreId: 21,
				StoreName: "ASCOT WA"
			},
			{
				LookupStoreId: 22,
				StoreName: "ASCOT WATERS WA"
			},
			{
				LookupStoreId: 23,
				StoreName: "ASHMORE QLD"
			},
			{
				LookupStoreId: 24,
				StoreName: "ASPLEY QLD"
			},
			{
				LookupStoreId: 25,
				StoreName: "ATHERTON QLD"
			},
			{
				LookupStoreId: 26,
				StoreName: "AUBURN NSW"
			},
			{
				LookupStoreId: 27,
				StoreName: "AUSTRALIA FAIR QLD"
			},
			{
				LookupStoreId: 28,
				StoreName: "AVONDALE HEIGHTS VIC"
			},
			{
				LookupStoreId: 29,
				StoreName: "AYR QLD"
			},
			{
				LookupStoreId: 30,
				StoreName: "ACACIA RIDGE QLD"
			},
			{
				LookupStoreId: 31,
				StoreName: "ALBANY ORANA WA"
			},
			{
				LookupStoreId: 32,
				StoreName: "AMSTEL VIC"
			},
			{
				LookupStoreId: 33,
				StoreName: "APPLECROSS II WA"
			},
			{
				LookupStoreId: 34,
				StoreName: "AUGUSTINE HEIGHTS QLD"
			},
			{
				LookupStoreId: 35,
				StoreName: "BACCHUS MARSH VIC"
			},
			{
				LookupStoreId: 36,
				StoreName: "BAIRNSDALE VIC"
			},
			{
				LookupStoreId: 37,
				StoreName: "BALDIVIS WA"
			},
			{
				LookupStoreId: 38,
				StoreName: "BALLAJURA WA"
			},
			{
				LookupStoreId: 39,
				StoreName: "BALLAN WESTBOUND VIC"
			},
			{
				LookupStoreId: 40,
				StoreName: "BALLARAT BAKERY HILL VIC"
			},
			{
				LookupStoreId: 41,
				StoreName: "BALLARAT STURT STREET VIC"
			},
			{
				LookupStoreId: 42,
				StoreName: "BALLINA CENTRAL NSW"
			},
			{
				LookupStoreId: 43,
				StoreName: "BALWYN VIC"
			},
			{
				LookupStoreId: 44,
				StoreName: "BANKSIA GROVE WA"
			},
			{
				LookupStoreId: 45,
				StoreName: "BANKSTOWN CENTRO F/C II NSW"
			},
			{
				LookupStoreId: 46,
				StoreName: "BANKSTOWN NSW"
			},
			{
				LookupStoreId: 47,
				StoreName: "BANORA POINT NSW"
			},
			{
				LookupStoreId: 48,
				StoreName: "BARGARA QLD"
			},
			{
				LookupStoreId: 49,
				StoreName: "BASS HILL NSW"
			},
			{
				LookupStoreId: 50,
				StoreName: "BASS VIC"
			},
			{
				LookupStoreId: 51,
				StoreName: "BATEAU BAY NSW"
			},
			{
				LookupStoreId: 52,
				StoreName: "BATEMANS BAY NSW"
			},
			{
				LookupStoreId: 53,
				StoreName: "BATHURST NSW"
			},
			{
				LookupStoreId: 54,
				StoreName: "BAYSWATER NORTH VIC"
			},
			{
				LookupStoreId: 55,
				StoreName: "BEACON HILL NSW"
			},
			{
				LookupStoreId: 56,
				StoreName: "BEAUDESERT QLD"
			},
			{
				LookupStoreId: 57,
				StoreName: "BEECHBORO WA"
			},
			{
				LookupStoreId: 58,
				StoreName: "BEELIAR VILLAGE WA"
			},
			{
				LookupStoreId: 59,
				StoreName: "BEENLEIGH QLD"
			},
			{
				LookupStoreId: 60,
				StoreName: "BEGA NSW"
			},
			{
				LookupStoreId: 61,
				StoreName: "BELCONNEN ACT"
			},
			{
				LookupStoreId: 62,
				StoreName: "BELCONNEN FOOD COURT ACT"
			},
			{
				LookupStoreId: 63,
				StoreName: "BELDON WA"
			},
			{
				LookupStoreId: 64,
				StoreName: "BELLBIRD PARK QLD"
			},
			{
				LookupStoreId: 65,
				StoreName: "BELLBOWRIE QLD"
			},
			{
				LookupStoreId: 66,
				StoreName: "BELMONT NSW"
			},
			{
				LookupStoreId: 67,
				StoreName: "BENALLA VIC"
			},
			{
				LookupStoreId: 68,
				StoreName: "BENDIGO VIC"
			},
			{
				LookupStoreId: 69,
				StoreName: "BENOWA QLD"
			},
			{
				LookupStoreId: 70,
				StoreName: "BERWICK SOUTH VIC"
			},
			{
				LookupStoreId: 71,
				StoreName: "BERWICK VIC"
			},
			{
				LookupStoreId: 72,
				StoreName: "BEXLEY NSW"
			},
			{
				LookupStoreId: 73,
				StoreName: "BICTON WA"
			},
			{
				LookupStoreId: 74,
				StoreName: "BLACKBURN VIC"
			},
			{
				LookupStoreId: 75,
				StoreName: "BLACKTOWN FOOD COURT II NSW"
			},
			{
				LookupStoreId: 76,
				StoreName: "BLACKTOWN II NSW"
			},
			{
				LookupStoreId: 77,
				StoreName: "BLACKTOWN MEGA CENTRE ST MARTINS VILLAGE NSW"
			},
			{
				LookupStoreId: 78,
				StoreName: "BLACKTOWN RWAY CONC NSW"
			},
			{
				LookupStoreId: 79,
				StoreName: "BLACKWATER QLD"
			},
			{
				LookupStoreId: 80,
				StoreName: "BLAXLAND NSW"
			},
			{
				LookupStoreId: 81,
				StoreName: "BOMADERRY NSW"
			},
			{
				LookupStoreId: 82,
				StoreName: "BONDI BEACH NSW"
			},
			{
				LookupStoreId: 83,
				StoreName: "BONDI JUNCTION INTERCHANGE NSW"
			},
			{
				LookupStoreId: 84,
				StoreName: "BONDI WESTFIELD II NSW"
			},
			{
				LookupStoreId: 85,
				StoreName: "BONNYRIGG HEIGHTS NSW"
			},
			{
				LookupStoreId: 86,
				StoreName: "BONNYRIGG NSW"
			},
			{
				LookupStoreId: 87,
				StoreName: "BOOVAL QLD"
			},
			{
				LookupStoreId: 88,
				StoreName: "BORONIA VIC"
			},
			{
				LookupStoreId: 89,
				StoreName: "BOURKE ST WEST VIC"
			},
			{
				LookupStoreId: 90,
				StoreName: "BOWEN QLD"
			},
			{
				LookupStoreId: 91,
				StoreName: "BOX HILL CENTRAL VIC"
			},
			{
				LookupStoreId: 92,
				StoreName: "BOX HILL NORTH VIC"
			},
			{
				LookupStoreId: 93,
				StoreName: "BOYNE ISLAND QLD"
			},
			{
				LookupStoreId: 94,
				StoreName: "BP BALLINA TRAVEL CENTRE NSW"
			},
			{
				LookupStoreId: 95,
				StoreName: "BP CABOOLTURE NORTHBOUND QLD"
			},
			{
				LookupStoreId: 96,
				StoreName: "BP CABOOLTURE SOUTHBOUND QLD"
			},
			{
				LookupStoreId: 97,
				StoreName: "BP CHINDERAH SOUTH NSW"
			},
			{
				LookupStoreId: 98,
				StoreName: "BP COOMERA QLD"
			},
			{
				LookupStoreId: 99,
				StoreName: "BP LOGAN MOTORWAY QLD"
			},
			{
				LookupStoreId: 100,
				StoreName: "BP STAPYLTON QLD"
			},
			{
				LookupStoreId: 101,
				StoreName: "BRACKEN RIDGE QLD"
			},
			{
				LookupStoreId: 102,
				StoreName: "BRADDON ACT"
			},
			{
				LookupStoreId: 103,
				StoreName: "BRAESIDE VIC"
			},
			{
				LookupStoreId: 104,
				StoreName: "BRASSALL QLD"
			},
			{
				LookupStoreId: 105,
				StoreName: "BRIBIE INTERCHANGE QLD"
			},
			{
				LookupStoreId: 106,
				StoreName: "BRIBIE ISLAND QLD"
			},
			{
				LookupStoreId: 107,
				StoreName: "BRIDGEWATER TAS"
			},
			{
				LookupStoreId: 108,
				StoreName: "BRIGHTON WA"
			},
			{
				LookupStoreId: 109,
				StoreName: "BRISBANE AIRPORT DRIVE QLD"
			},
			{
				LookupStoreId: 110,
				StoreName: "BROADBEACH II QLD"
			},
			{
				LookupStoreId: 111,
				StoreName: "BROADBEACH/NEICON PLAZA QLD"
			},
			{
				LookupStoreId: 112,
				StoreName: "BROADMEADOW II NSW"
			},
			{
				LookupStoreId: 113,
				StoreName: "BROADMEADOWS VIC"
			},
			{
				LookupStoreId: 114,
				StoreName: "BROADWAY NSW"
			},
			{
				LookupStoreId: 115,
				StoreName: "BROKEN HILL NSW"
			},
			{
				LookupStoreId: 116,
				StoreName: "BROOKLYN VIC"
			},
			{
				LookupStoreId: 117,
				StoreName: "BROOKSIDE QLD"
			},
			{
				LookupStoreId: 118,
				StoreName: "BROOKVALE NSW"
			},
			{
				LookupStoreId: 119,
				StoreName: "BROOME WA"
			},
			{
				LookupStoreId: 120,
				StoreName: "BROWNS PLAINS QLD"
			},
			{
				LookupStoreId: 121,
				StoreName: "BRUNSWICK EAST VIC"
			},
			{
				LookupStoreId: 122,
				StoreName: "BRUNSWICK VIC"
			},
			{
				LookupStoreId: 123,
				StoreName: "BUNBURY SOUTH WA"
			},
			{
				LookupStoreId: 124,
				StoreName: "BUNBURY WA"
			},
			{
				LookupStoreId: 125,
				StoreName: "BUNDABERG CITY QLD"
			},
			{
				LookupStoreId: 126,
				StoreName: "BUNDABERG QLD"
			},
			{
				LookupStoreId: 127,
				StoreName: "BURLEIGH HEADS QLD"
			},
			{
				LookupStoreId: 128,
				StoreName: "BURLEIGH WATERS QLD"
			},
			{
				LookupStoreId: 129,
				StoreName: "BURNIE TAS"
			},
			{
				LookupStoreId: 130,
				StoreName: "BURNLEY VIC"
			},
			{
				LookupStoreId: 131,
				StoreName: "BURPENGARY QLD"
			},
			{
				LookupStoreId: 132,
				StoreName: "BURWOOD VIC"
			},
			{
				LookupStoreId: 133,
				StoreName: "BURWOOD WESTFIELD NSW"
			},
			{
				LookupStoreId: 134,
				StoreName: "BUSSELTON WA"
			},
			{
				LookupStoreId: 135,
				StoreName: "BUTLER WA"
			},
			{
				LookupStoreId: 136,
				StoreName: "BYFORD WA"
			},
			{
				LookupStoreId: 137,
				StoreName: "BELMONT WA"
			},
			{
				LookupStoreId: 138,
				StoreName: "BENNETTS GREEN NSW"
			},
			{
				LookupStoreId: 139,
				StoreName: "BLACKTOWN SPORTS PARK NSW"
			},
			{
				LookupStoreId: 140,
				StoreName: "BLIGH PARK NSW"
			},
			{
				LookupStoreId: 141,
				StoreName: "BOURKE & RUSSELL VIC"
			},
			{
				LookupStoreId: 142,
				StoreName: "CABOOLTURE CITY QLD"
			},
			{
				LookupStoreId: 143,
				StoreName: "CABOOLTURE QLD"
			},
			{
				LookupStoreId: 144,
				StoreName: "CAIRNS CENTRAL QLD"
			},
			{
				LookupStoreId: 145,
				StoreName: "CAIRNS CITY QLD"
			},
			{
				LookupStoreId: 146,
				StoreName: "CAIRNS ESPLANADE QLD"
			},
			{
				LookupStoreId: 147,
				StoreName: "CAIRNS QLD"
			},
			{
				LookupStoreId: 148,
				StoreName: "CALAMVALE QLD"
			},
			{
				LookupStoreId: 149,
				StoreName: "CALDER HIGHWAY SOUTH VIC"
			},
			{
				LookupStoreId: 150,
				StoreName: "CALDER NORTHBOUND VIC"
			},
			{
				LookupStoreId: 151,
				StoreName: "CALDERMEADE VIC"
			},
			{
				LookupStoreId: 152,
				StoreName: "CALLIOPE TRAVEL CENTRE QLD"
			},
			{
				LookupStoreId: 153,
				StoreName: "CALOUNDRA QLD"
			},
			{
				LookupStoreId: 154,
				StoreName: "CAMBRIDGE GARDENS NSW"
			},
			{
				LookupStoreId: 155,
				StoreName: "CAMDEN II NSW"
			},
			{
				LookupStoreId: 156,
				StoreName: "CAMDEN PARK SA"
			},
			{
				LookupStoreId: 157,
				StoreName: "CAMPBELLFIELD VIC"
			},
			{
				LookupStoreId: 158,
				StoreName: "CAMPBELLTOWN MALL II NSW"
			},
			{
				LookupStoreId: 159,
				StoreName: "CAMPBELLTOWN NSW"
			},
			{
				LookupStoreId: 160,
				StoreName: "CANBERRA CENTRE II ACT"
			},
			{
				LookupStoreId: 161,
				StoreName: "CANBERRA CITY ACT"
			},
			{
				LookupStoreId: 162,
				StoreName: "CANNING VALE WA"
			},
			{
				LookupStoreId: 163,
				StoreName: "CANNON HILL QLD"
			},
			{
				LookupStoreId: 164,
				StoreName: "CANNONVALE QLD"
			},
			{
				LookupStoreId: 165,
				StoreName: "CAPALABA QLD"
			},
			{
				LookupStoreId: 166,
				StoreName: "CARINA HEIGHTS QLD"
			},
			{
				LookupStoreId: 167,
				StoreName: "CARINDALE FOOD COURT QLD"
			},
			{
				LookupStoreId: 168,
				StoreName: "CARINGBAH NSW"
			},
			{
				LookupStoreId: 169,
				StoreName: "CARLINGFORD FOOD COURT NSW"
			},
			{
				LookupStoreId: 170,
				StoreName: "CARNES HILL NSW"
			},
			{
				LookupStoreId: 171,
				StoreName: "CAROLINE SPRINGS VIC"
			},
			{
				LookupStoreId: 172,
				StoreName: "CAROUSEL FOODCOURT WA"
			},
			{
				LookupStoreId: 173,
				StoreName: "CARRUM DOWNS VIC"
			},
			{
				LookupStoreId: 174,
				StoreName: "CARTWRIGHT NSW"
			},
			{
				LookupStoreId: 175,
				StoreName: "CASINO NSW"
			},
			{
				LookupStoreId: 176,
				StoreName: "CASTLE HILL NSW"
			},
			{
				LookupStoreId: 177,
				StoreName: "CASUARINA NT"
			},
			{
				LookupStoreId: 178,
				StoreName: "CASULA NSW"
			},
			{
				LookupStoreId: 179,
				StoreName: "CAVILL III QLD"
			},
			{
				LookupStoreId: 180,
				StoreName: "CENTRAL STATION QLD"
			},
			{
				LookupStoreId: 181,
				StoreName: "CESSNOCK NSW"
			},
			{
				LookupStoreId: 182,
				StoreName: "CHAPEL STREET VIC"
			},
			{
				LookupStoreId: 183,
				StoreName: "CHARLESTOWN NSW"
			},
			{
				LookupStoreId: 184,
				StoreName: "CHARLESTOWN SQUARE NSW"
			},
			{
				LookupStoreId: 185,
				StoreName: "CHARNWOOD ACT"
			},
			{
				LookupStoreId: 186,
				StoreName: "CHARTERS TOWERS QLD"
			},
			{
				LookupStoreId: 187,
				StoreName: "CHATSWOOD INTERCHANGE NSW"
			},
			{
				LookupStoreId: 188,
				StoreName: "CHELSEA HEIGHTS VIC"
			},
			{
				LookupStoreId: 189,
				StoreName: "CHELTENHAM VIC"
			},
			{
				LookupStoreId: 190,
				StoreName: "CHERMSIDE F/C QLD"
			},
			{
				LookupStoreId: 191,
				StoreName: "CHERMSIDE QLD"
			},
			{
				LookupStoreId: 192,
				StoreName: "CHILDERS QLD"
			},
			{
				LookupStoreId: 193,
				StoreName: "CHINCHILLA QLD"
			},
			{
				LookupStoreId: 194,
				StoreName: "CLAYTON II VIC"
			},
			{
				LookupStoreId: 195,
				StoreName: "CLAYTON SOUTH VIC"
			},
			{
				LookupStoreId: 196,
				StoreName: "CLEVELAND QLD"
			},
			{
				LookupStoreId: 197,
				StoreName: "CLIFFORD GARDENS QLD"
			},
			{
				LookupStoreId: 198,
				StoreName: "CLIFTON HILL VIC"
			},
			{
				LookupStoreId: 199,
				StoreName: "CLONTARF QLD"
			},
			{
				LookupStoreId: 200,
				StoreName: "CLYDE VIC"
			},
			{
				LookupStoreId: 201,
				StoreName: "COBRAM VIC"
			},
			{
				LookupStoreId: 202,
				StoreName: "COFFS NORTH NSW"
			},
			{
				LookupStoreId: 203,
				StoreName: "COFFS SERVICE CENTRE NSW"
			},
			{
				LookupStoreId: 204,
				StoreName: "COLAC VIC"
			},
			{
				LookupStoreId: 205,
				StoreName: "COLLIE WA"
			},
			{
				LookupStoreId: 206,
				StoreName: "COLLINGWOOD VIC"
			},
			{
				LookupStoreId: 207,
				StoreName: "COLLINSWOOD SA"
			},
			{
				LookupStoreId: 208,
				StoreName: "COLONNADES II SA"
			},
			{
				LookupStoreId: 209,
				StoreName: "CONDER ACT"
			},
			{
				LookupStoreId: 210,
				StoreName: "COOGEE NSW"
			},
			{
				LookupStoreId: 211,
				StoreName: "COOLALINGA NT"
			},
			{
				LookupStoreId: 212,
				StoreName: "COOLANGATTA II QLD"
			},
			{
				LookupStoreId: 213,
				StoreName: "COOLUM BEACH QLD"
			},
			{
				LookupStoreId: 214,
				StoreName: "COOMA NSW"
			},
			{
				LookupStoreId: 215,
				StoreName: "COORPAROO QLD"
			},
			{
				LookupStoreId: 216,
				StoreName: "CORIO VIC"
			},
			{
				LookupStoreId: 217,
				StoreName: "CORIO VILLAGE VIC"
			},
			{
				LookupStoreId: 218,
				StoreName: "COROWA VIC"
			},
			{
				LookupStoreId: 219,
				StoreName: "COWRA NSW"
			},
			{
				LookupStoreId: 220,
				StoreName: "CRAIGIEBURN NORTH VIC"
			},
			{
				LookupStoreId: 221,
				StoreName: "CRAIGIEBURN VIC"
			},
			{
				LookupStoreId: 222,
				StoreName: "CRANBOURNE NORTH VIC"
			},
			{
				LookupStoreId: 223,
				StoreName: "CRANBOURNE VIC"
			},
			{
				LookupStoreId: 224,
				StoreName: "CREMORNE NSW"
			},
			{
				LookupStoreId: 225,
				StoreName: "CROSS ROADS SA"
			},
			{
				LookupStoreId: 226,
				StoreName: "CROWN PERTH WA"
			},
			{
				LookupStoreId: 227,
				StoreName: "CROYDON NSW"
			},
			{
				LookupStoreId: 228,
				StoreName: "CROYDON PARK NSW"
			},
			{
				LookupStoreId: 229,
				StoreName: "CROYDON SA"
			},
			{
				LookupStoreId: 230,
				StoreName: "CROYDON VIC"
			},
			{
				LookupStoreId: 231,
				StoreName: "CURRAMBINE WA"
			},
			{
				LookupStoreId: 232,
				StoreName: "CURRIMUNDI II QLD"
			},
			{
				LookupStoreId: 233,
				StoreName: "CURTIS RD MUNNO PARA WEST SA"
			},
			{
				LookupStoreId: 234,
				StoreName: "CALIFORNIA GULLY VIC"
			},
			{
				LookupStoreId: 235,
				StoreName: "CAMERON PARK NSW"
			},
			{
				LookupStoreId: 236,
				StoreName: "CAMIRA QLD"
			},
			{
				LookupStoreId: 237,
				StoreName: "CANNINGTON WA"
			},
			{
				LookupStoreId: 238,
				StoreName: "CASTLE TOWERS II NSW"
			},
			{
				LookupStoreId: 239,
				StoreName: "CHADSTONE SHOPPING CENTRE VIC"
			},
			{
				LookupStoreId: 240,
				StoreName: "CHINDERAH NORTHBOUND NSW"
			},
			{
				LookupStoreId: 241,
				StoreName: "CLARKSON WA"
			},
			{
				LookupStoreId: 242,
				StoreName: "CLYDE NORTH VIC"
			},
			{
				LookupStoreId: 243,
				StoreName: "COLMSLIE BUSINESS PARK QLD"
			},
			{
				LookupStoreId: 244,
				StoreName: "CRANEBROOK NSW"
			},
			{
				LookupStoreId: 245,
				StoreName: "DALBY QLD"
			},
			{
				LookupStoreId: 246,
				StoreName: "DALYELLUP WA"
			},
			{
				LookupStoreId: 247,
				StoreName: "DANDENONG NORTH VIC"
			},
			{
				LookupStoreId: 248,
				StoreName: "DANDENONG PLAZA VIC"
			},
			{
				LookupStoreId: 249,
				StoreName: "DANDENONG VIC"
			},
			{
				LookupStoreId: 250,
				StoreName: "DAPTO NSW"
			},
			{
				LookupStoreId: 251,
				StoreName: "DARLING QUARTER NSW"
			},
			{
				LookupStoreId: 252,
				StoreName: "DARLING SQUARE NSW"
			},
			{
				LookupStoreId: 253,
				StoreName: "DARLINGTON SA"
			},
			{
				LookupStoreId: 254,
				StoreName: "DARWIN CENTRAL NT"
			},
			{
				LookupStoreId: 255,
				StoreName: "DECEPTION BAY QLD"
			},
			{
				LookupStoreId: 256,
				StoreName: "DEER PARK VIC"
			},
			{
				LookupStoreId: 257,
				StoreName: "DELACOMBE VIC"
			},
			{
				LookupStoreId: 258,
				StoreName: "DELAHEY VIC"
			},
			{
				LookupStoreId: 259,
				StoreName: "DENILIQUIN NSW"
			},
			{
				LookupStoreId: 260,
				StoreName: "DERRIMUT VIC"
			},
			{
				LookupStoreId: 261,
				StoreName: "DEVONPORT HOMEMAKER CENTRE TAS"
			},
			{
				LookupStoreId: 262,
				StoreName: "DEVONPORT TAS"
			},
			{
				LookupStoreId: 263,
				StoreName: "DIAMOND CREEK VIC"
			},
			{
				LookupStoreId: 264,
				StoreName: "DICKSON ACT"
			},
			{
				LookupStoreId: 265,
				StoreName: "DONCASTER F/C II VIC"
			},
			{
				LookupStoreId: 266,
				StoreName: "DOOLANDELLA QLD"
			},
			{
				LookupStoreId: 267,
				StoreName: "DOONSIDE NSW"
			},
			{
				LookupStoreId: 268,
				StoreName: "DOREEN VIC"
			},
			{
				LookupStoreId: 269,
				StoreName: "DOVETON VIC"
			},
			{
				LookupStoreId: 270,
				StoreName: "DROUIN VIC"
			},
			{
				LookupStoreId: 271,
				StoreName: "DRUMMOYNE NSW"
			},
			{
				LookupStoreId: 272,
				StoreName: "DUBBO NSW"
			},
			{
				LookupStoreId: 273,
				StoreName: "DUBBO WEST NSW"
			},
			{
				LookupStoreId: 274,
				StoreName: "DUNCRAIG WA"
			},
			{
				LookupStoreId: 275,
				StoreName: "DURAL NSW"
			},
			{
				LookupStoreId: 276,
				StoreName: "DUBBO EAST NSW"
			},
			{
				LookupStoreId: 277,
				StoreName: "EAGLE VALE NSW"
			},
			{
				LookupStoreId: 278,
				StoreName: "EAGLEBY QLD"
			},
			{
				LookupStoreId: 279,
				StoreName: "EAST DONCASTER VIC"
			},
			{
				LookupStoreId: 280,
				StoreName: "EAST VICTORIA PARK WA"
			},
			{
				LookupStoreId: 281,
				StoreName: "EASTGARDENS NSW"
			},
			{
				LookupStoreId: 282,
				StoreName: "EASTLINK NORTHBOUND VIC"
			},
			{
				LookupStoreId: 283,
				StoreName: "EASTLINK SOUTHBOUND VIC"
			},
			{
				LookupStoreId: 284,
				StoreName: "EATON WA"
			},
			{
				LookupStoreId: 285,
				StoreName: "ECHUCA VIC"
			},
			{
				LookupStoreId: 286,
				StoreName: "EDGEWORTH NSW"
			},
			{
				LookupStoreId: 287,
				StoreName: "EDMONDSON PARK NSW"
			},
			{
				LookupStoreId: 288,
				StoreName: "EDMONTON QLD"
			},
			{
				LookupStoreId: 289,
				StoreName: "EIGHT MILE PLAINS QLD"
			},
			{
				LookupStoreId: 290,
				StoreName: "ELANORA QLD"
			},
			{
				LookupStoreId: 291,
				StoreName: "ELIZABETH FOODCOURT SA"
			},
			{
				LookupStoreId: 292,
				StoreName: "ELIZABETH SA"
			},
			{
				LookupStoreId: 293,
				StoreName: "ELIZABETH STREET VIC"
			},
			{
				LookupStoreId: 294,
				StoreName: "ELLENBROOK WA"
			},
			{
				LookupStoreId: 295,
				StoreName: "ELSTERNWICK VIC"
			},
			{
				LookupStoreId: 296,
				StoreName: "ELTHAM VIC"
			},
			{
				LookupStoreId: 297,
				StoreName: "EMERALD QLD"
			},
			{
				LookupStoreId: 298,
				StoreName: "EMERTON II NSW"
			},
			{
				LookupStoreId: 299,
				StoreName: "EMU PLAINS NSW"
			},
			{
				LookupStoreId: 300,
				StoreName: "ENDEAVOUR HILLS VIC"
			},
			{
				LookupStoreId: 301,
				StoreName: "ENFIELD NSW"
			},
			{
				LookupStoreId: 302,
				StoreName: "ENFIELD SA"
			},
			{
				LookupStoreId: 303,
				StoreName: "ENGADINE NSW"
			},
			{
				LookupStoreId: 304,
				StoreName: "EPPING PLAZA VIC"
			},
			{
				LookupStoreId: 305,
				StoreName: "EPPING VIC"
			},
			{
				LookupStoreId: 306,
				StoreName: "EPSOM VIC"
			},
			{
				LookupStoreId: 307,
				StoreName: "ERINA FAIR FOOD COURT NSW"
			},
			{
				LookupStoreId: 308,
				StoreName: "ERINA NSW"
			},
			{
				LookupStoreId: 309,
				StoreName: "ERINDALE ACT"
			},
			{
				LookupStoreId: 310,
				StoreName: "ESPERANCE WA"
			},
			{
				LookupStoreId: 311,
				StoreName: "EUROA VIC"
			},
			{
				LookupStoreId: 312,
				StoreName: "EDENS CROSSING QLD"
			},
			{
				LookupStoreId: 313,
				StoreName: "EMERALD HILLS NSW"
			},
			{
				LookupStoreId: 314,
				StoreName: "F3 NORTH (WYONG NTH) NSW"
			},
			{
				LookupStoreId: 315,
				StoreName: "F3 SOUTH (WYONG STH) NSW"
			},
			{
				LookupStoreId: 316,
				StoreName: "FAIRFIELD II NSW"
			},
			{
				LookupStoreId: 317,
				StoreName: "FAIRFIELD WATERS QLD"
			},
			{
				LookupStoreId: 318,
				StoreName: "FAIRYMEADOW II NSW"
			},
			{
				LookupStoreId: 319,
				StoreName: "FALCON WA"
			},
			{
				LookupStoreId: 320,
				StoreName: "FAWKNER II VIC"
			},
			{
				LookupStoreId: 321,
				StoreName: "FELIXSTOW SA"
			},
			{
				LookupStoreId: 322,
				StoreName: "FERNTREE GULLY VIC"
			},
			{
				LookupStoreId: 323,
				StoreName: "FIGTREE NSW"
			},
			{
				LookupStoreId: 324,
				StoreName: "FIVE DOCK NSW"
			},
			{
				LookupStoreId: 325,
				StoreName: "FLEMINGTON VIC"
			},
			{
				LookupStoreId: 326,
				StoreName: "FOOTSCRAY VIC"
			},
			{
				LookupStoreId: 327,
				StoreName: "FORBES NSW"
			},
			{
				LookupStoreId: 328,
				StoreName: "FOREST HILL VIC"
			},
			{
				LookupStoreId: 329,
				StoreName: "FOREST LAKE QLD"
			},
			{
				LookupStoreId: 330,
				StoreName: "FOREST LAKES WA"
			},
			{
				LookupStoreId: 331,
				StoreName: "FORESTWAY NSW"
			},
			{
				LookupStoreId: 332,
				StoreName: "FORRESTFIELD WA"
			},
			{
				LookupStoreId: 333,
				StoreName: "FORSTER NSW"
			},
			{
				LookupStoreId: 334,
				StoreName: "FOUNTAIN GATE VIC"
			},
			{
				LookupStoreId: 335,
				StoreName: "FRANKSTON II VIC"
			},
			{
				LookupStoreId: 336,
				StoreName: "FRANKSTON NORTH VIC"
			},
			{
				LookupStoreId: 337,
				StoreName: "FRESHWATER PLACE VIC"
			},
			{
				LookupStoreId: 338,
				StoreName: "FREWVILLE SA"
			},
			{
				LookupStoreId: 339,
				StoreName: "FULHAM GARDENS SA"
			},
			{
				LookupStoreId: 340,
				StoreName: "FYSHWICK ACT"
			},
			{
				LookupStoreId: 341,
				StoreName: "FLAGSTONE QLD"
			},
			{
				LookupStoreId: 342,
				StoreName: "FORRESTDALE WA"
			},
			{
				LookupStoreId: 343,
				StoreName: "FREESTANDING CHADSTONE VIC"
			},
			{
				LookupStoreId: 344,
				StoreName: "GARDEN CITY QLD"
			},
			{
				LookupStoreId: 345,
				StoreName: "GATTON CENTRAL QLD"
			},
			{
				LookupStoreId: 346,
				StoreName: "GATTON QLD"
			},
			{
				LookupStoreId: 347,
				StoreName: "GAWLER SA"
			},
			{
				LookupStoreId: 348,
				StoreName: "GEELONG BYPASS NORTHBOUND VIC"
			},
			{
				LookupStoreId: 349,
				StoreName: "GEELONG BYPASS SOUTHBOUND VIC"
			},
			{
				LookupStoreId: 350,
				StoreName: "GEELONG CENTRAL VIC"
			},
			{
				LookupStoreId: 351,
				StoreName: "GEELONG NORTH VIC"
			},
			{
				LookupStoreId: 352,
				StoreName: "GEELONG WEST VIC"
			},
			{
				LookupStoreId: 353,
				StoreName: "GEELONG(BELMONT) VIC"
			},
			{
				LookupStoreId: 354,
				StoreName: "GENERAL HOLMES DRIVE NSW"
			},
			{
				LookupStoreId: 355,
				StoreName: "GERALDTON HOMEMAKER CENTRE WA"
			},
			{
				LookupStoreId: 356,
				StoreName: "GERALDTON WA"
			},
			{
				LookupStoreId: 357,
				StoreName: "GILLES PLAINS SA"
			},
			{
				LookupStoreId: 358,
				StoreName: "GIRRAWHEEN WA"
			},
			{
				LookupStoreId: 359,
				StoreName: "GISBORNE VIC"
			},
			{
				LookupStoreId: 360,
				StoreName: "GLADESVILLE NSW"
			},
			{
				LookupStoreId: 361,
				StoreName: "GLADSTONE CITY QLD"
			},
			{
				LookupStoreId: 362,
				StoreName: "GLADSTONE KIN KORA QLD"
			},
			{
				LookupStoreId: 363,
				StoreName: "GLADSTONE KIRKWOOD QLD"
			},
			{
				LookupStoreId: 364,
				StoreName: "GLASS HOUSE MOUNTAINS QLD"
			},
			{
				LookupStoreId: 365,
				StoreName: "GLEN INNES NSW"
			},
			{
				LookupStoreId: 366,
				StoreName: "GLEN WAVERLEY VIC"
			},
			{
				LookupStoreId: 367,
				StoreName: "GLENDALE NSW"
			},
			{
				LookupStoreId: 368,
				StoreName: "GLENMORE PARK NSW"
			},
			{
				LookupStoreId: 369,
				StoreName: "GLENMORE QLD"
			},
			{
				LookupStoreId: 370,
				StoreName: "GLENQUARIE NSW"
			},
			{
				LookupStoreId: 371,
				StoreName: "GLENROWAN NORTH VIC"
			},
			{
				LookupStoreId: 372,
				StoreName: "GLENROWAN SOUTH VIC"
			},
			{
				LookupStoreId: 373,
				StoreName: "GOLD CREEK ACT"
			},
			{
				LookupStoreId: 374,
				StoreName: "GOLDEN GROVE SA"
			},
			{
				LookupStoreId: 375,
				StoreName: "GOODNA QLD"
			},
			{
				LookupStoreId: 376,
				StoreName: "GOONDIWINDI QLD"
			},
			{
				LookupStoreId: 377,
				StoreName: "GOONELLABAH NSW"
			},
			{
				LookupStoreId: 378,
				StoreName: "GORDON NSW"
			},
			{
				LookupStoreId: 379,
				StoreName: "GORDONVALE QLD"
			},
			{
				LookupStoreId: 380,
				StoreName: "GOSFORD IMPERIAL NSW"
			},
			{
				LookupStoreId: 381,
				StoreName: "GOSFORD WEST NSW"
			},
			{
				LookupStoreId: 382,
				StoreName: "GOSNELLS WA"
			},
			{
				LookupStoreId: 383,
				StoreName: "GOULBURN NSW"
			},
			{
				LookupStoreId: 384,
				StoreName: "GOULBURN SOUTH NSW"
			},
			{
				LookupStoreId: 385,
				StoreName: "GRACEMERE QLD"
			},
			{
				LookupStoreId: 386,
				StoreName: "GRAFTON NSW"
			},
			{
				LookupStoreId: 387,
				StoreName: "GRAND CENTRAL QLD"
			},
			{
				LookupStoreId: 388,
				StoreName: "GRAND PLAZA QLD"
			},
			{
				LookupStoreId: 389,
				StoreName: "GRANVILLE NSW"
			},
			{
				LookupStoreId: 390,
				StoreName: "GREEN SQUARE NSW"
			},
			{
				LookupStoreId: 391,
				StoreName: "GREENACRE II NSW"
			},
			{
				LookupStoreId: 392,
				StoreName: "GREENACRE NORTH NSW"
			},
			{
				LookupStoreId: 393,
				StoreName: "GREENSBOROUGH PLAZA F/C VIC"
			},
			{
				LookupStoreId: 394,
				StoreName: "GREENSBOROUGH VIC"
			},
			{
				LookupStoreId: 395,
				StoreName: "GREGORY HILLS NSW"
			},
			{
				LookupStoreId: 396,
				StoreName: "GRETA NSW"
			},
			{
				LookupStoreId: 397,
				StoreName: "GRIFFITH NSW"
			},
			{
				LookupStoreId: 398,
				StoreName: "GUILDFORD NSW"
			},
			{
				LookupStoreId: 399,
				StoreName: "GUNDAGAI NSW"
			},
			{
				LookupStoreId: 400,
				StoreName: "GUNGAHLIN ACT"
			},
			{
				LookupStoreId: 401,
				StoreName: "GUNNEDAH NSW"
			},
			{
				LookupStoreId: 402,
				StoreName: "GYMPIE QLD"
			},
			{
				LookupStoreId: 403,
				StoreName: "GILLIESTON HEIGHTS NSW"
			},
			{
				LookupStoreId: 404,
				StoreName: "GREEN FIELDS SA"
			},
			{
				LookupStoreId: 405,
				StoreName: "GREENVALE LAKES VICTORIA"
			},
			{
				LookupStoreId: 406,
				StoreName: "GREYSTANES NSW"
			},
			{
				LookupStoreId: 407,
				StoreName: "HABERFIELD NSW"
			},
			{
				LookupStoreId: 408,
				StoreName: "HALLETT COVE SA"
			},
			{
				LookupStoreId: 409,
				StoreName: "HAMILTON VIC"
			},
			{
				LookupStoreId: 410,
				StoreName: "HAMPTON PARK VIC"
			},
			{
				LookupStoreId: 411,
				StoreName: "HAPPY VALLEY SA"
			},
			{
				LookupStoreId: 412,
				StoreName: "HARBOUR TOWN QLD"
			},
			{
				LookupStoreId: 413,
				StoreName: "HARBOURSIDE NSW"
			},
			{
				LookupStoreId: 414,
				StoreName: "HARRISTOWN QLD"
			},
			{
				LookupStoreId: 415,
				StoreName: "HASTINGS VIC"
			},
			{
				LookupStoreId: 416,
				StoreName: "HAWTHORN VIC"
			},
			{
				LookupStoreId: 417,
				StoreName: "HAY STREET EAST WA"
			},
			{
				LookupStoreId: 418,
				StoreName: "HEATHCOTE NSW"
			},
			{
				LookupStoreId: 419,
				StoreName: "HEATHERBRAE NSW"
			},
			{
				LookupStoreId: 420,
				StoreName: "HEATHERTON VIC"
			},
			{
				LookupStoreId: 421,
				StoreName: "HEIDELBERG VIC"
			},
			{
				LookupStoreId: 422,
				StoreName: "HELENSVALE QLD"
			},
			{
				LookupStoreId: 423,
				StoreName: "HELENSVALE WESTFIELD QLD"
			},
			{
				LookupStoreId: 424,
				StoreName: "HERVEY BAY QLD"
			},
			{
				LookupStoreId: 425,
				StoreName: "HEXHAM NSW"
			},
			{
				LookupStoreId: 426,
				StoreName: "HIGH WYCOMBE WA"
			},
			{
				LookupStoreId: 427,
				StoreName: "HIGHFIELDS QLD"
			},
			{
				LookupStoreId: 428,
				StoreName: "HIGHPOINT F/C II VIC"
			},
			{
				LookupStoreId: 429,
				StoreName: "HINCHINBROOK NSW"
			},
			{
				LookupStoreId: 430,
				StoreName: "HINDLEY STREET SA"
			},
			{
				LookupStoreId: 431,
				StoreName: "HOBART CBD TAS"
			},
			{
				LookupStoreId: 432,
				StoreName: "HODDLE ST VIC"
			},
			{
				LookupStoreId: 433,
				StoreName: "HOGANS CORNER VIC"
			},
			{
				LookupStoreId: 434,
				StoreName: "HOLLYWOOD PLAZA SA"
			},
			{
				LookupStoreId: 435,
				StoreName: "HOLMESGLEN VIC"
			},
			{
				LookupStoreId: 436,
				StoreName: "HOLMVIEW QLD"
			},
			{
				LookupStoreId: 437,
				StoreName: "HOPE ISLAND QLD"
			},
			{
				LookupStoreId: 438,
				StoreName: "HOPPERS CROSSING VIC"
			},
			{
				LookupStoreId: 439,
				StoreName: "HORNSBY WESTFIELD NSW"
			},
			{
				LookupStoreId: 440,
				StoreName: "HORSHAM VIC"
			},
			{
				LookupStoreId: 441,
				StoreName: "HURLSTONE PARK NSW"
			},
			{
				LookupStoreId: 442,
				StoreName: "HURSTVILLE CENTRAL NSW"
			},
			{
				LookupStoreId: 443,
				StoreName: "HURSTVILLE SOUTH NSW"
			},
			{
				LookupStoreId: 444,
				StoreName: "HURSTVILLE W/F NSW"
			},
			{
				LookupStoreId: 445,
				StoreName: "HARRISDALE WA"
			},
			{
				LookupStoreId: 446,
				StoreName: "HOXTON PARK M7 NSW"
			},
			{
				LookupStoreId: 447,
				StoreName: "INDOOROOPILLY F/C QLD"
			},
			{
				LookupStoreId: 448,
				StoreName: "INDOOROOPILLY QLD"
			},
			{
				LookupStoreId: 449,
				StoreName: "INGHAM QLD"
			},
			{
				LookupStoreId: 450,
				StoreName: "INNALOO WA"
			},
			{
				LookupStoreId: 451,
				StoreName: "INNISFAIL QLD"
			},
			{
				LookupStoreId: 452,
				StoreName: "INTERNATIONAL ARRIVALS NSW"
			},
			{
				LookupStoreId: 453,
				StoreName: "INVERELL NSW"
			},
			{
				LookupStoreId: 454,
				StoreName: "INVERMAY TAS"
			},
			{
				LookupStoreId: 455,
				StoreName: "IPSWICH CBD QLD"
			},
			{
				LookupStoreId: 456,
				StoreName: "IPSWICH RIVERLINK QLD"
			},
			{
				LookupStoreId: 457,
				StoreName: "IRYMPLE VIC"
			},
			{
				LookupStoreId: 458,
				StoreName: "INTERNATIONAL AIRSIDE II NSW"
			},
			{
				LookupStoreId: 459,
				StoreName: "INTERNATIONAL AIRSIDE LLL NSW"
			},
			{
				LookupStoreId: 460,
				StoreName: "JIMBOOMBA QLD"
			},
			{
				LookupStoreId: 461,
				StoreName: "JINDALEE QLD"
			},
			{
				LookupStoreId: 462,
				StoreName: "JOHNSTON NT"
			},
			{
				LookupStoreId: 463,
				StoreName: "JOLIMONT WA"
			},
			{
				LookupStoreId: 464,
				StoreName: "JOONDALUP WA"
			},
			{
				LookupStoreId: 465,
				StoreName: "JERRABOMBERRA NSW"
			},
			{
				LookupStoreId: 466,
				StoreName: "KADINA SA"
			},
			{
				LookupStoreId: 467,
				StoreName: "KALGOORLIE CBD WA"
			},
			{
				LookupStoreId: 468,
				StoreName: "KALGOORLIE WA"
			},
			{
				LookupStoreId: 469,
				StoreName: "KALLANGUR QLD"
			},
			{
				LookupStoreId: 470,
				StoreName: "KANGAROO FLAT VIC"
			},
			{
				LookupStoreId: 471,
				StoreName: "KANGAROO POINT QLD"
			},
			{
				LookupStoreId: 472,
				StoreName: "KARAWARA WA"
			},
			{
				LookupStoreId: 473,
				StoreName: "KARINGAL HUB VIC"
			},
			{
				LookupStoreId: 474,
				StoreName: "KARINGAL VIC"
			},
			{
				LookupStoreId: 475,
				StoreName: "KARRATHA WA"
			},
			{
				LookupStoreId: 476,
				StoreName: "KATHERINE NT"
			},
			{
				LookupStoreId: 477,
				StoreName: "KAWANA SHOPPINGWORLD II QLD"
			},
			{
				LookupStoreId: 478,
				StoreName: "KEILOR PARK VIC"
			},
			{
				LookupStoreId: 479,
				StoreName: "KELLYVILLE NORTH NSW"
			},
			{
				LookupStoreId: 480,
				StoreName: "KELLYVILLE NSW"
			},
			{
				LookupStoreId: 481,
				StoreName: "KELMSCOTT WA"
			},
			{
				LookupStoreId: 482,
				StoreName: "KELSO NSW"
			},
			{
				LookupStoreId: 483,
				StoreName: "KEMPSEY NSW"
			},
			{
				LookupStoreId: 484,
				StoreName: "KEMPSEY SOUTH SERVICE CENTRE NSW"
			},
			{
				LookupStoreId: 485,
				StoreName: "KENMORE QLD"
			},
			{
				LookupStoreId: 486,
				StoreName: "KEW VIC"
			},
			{
				LookupStoreId: 487,
				StoreName: "KEYSBOROUGH VIC"
			},
			{
				LookupStoreId: 488,
				StoreName: "KILMORE VIC"
			},
			{
				LookupStoreId: 489,
				StoreName: "KILSYTH VIC"
			},
			{
				LookupStoreId: 490,
				StoreName: "KINCUMBER NSW"
			},
			{
				LookupStoreId: 491,
				StoreName: "KING STREET NSW"
			},
			{
				LookupStoreId: 492,
				StoreName: "KINGAROY QLD"
			},
			{
				LookupStoreId: 493,
				StoreName: "KINGS CROSS NSW"
			},
			{
				LookupStoreId: 494,
				StoreName: "KINGS MEADOWS TAS"
			},
			{
				LookupStoreId: 495,
				StoreName: "KINGS PARK NSW"
			},
			{
				LookupStoreId: 496,
				StoreName: "KINGSBURY VIC"
			},
			{
				LookupStoreId: 497,
				StoreName: "KINGSFORD NSW"
			},
			{
				LookupStoreId: 498,
				StoreName: "KINGSTON TAS"
			},
			{
				LookupStoreId: 499,
				StoreName: "KIPPAX ACT"
			},
			{
				LookupStoreId: 500,
				StoreName: "KIRRAWEE NSW"
			},
			{
				LookupStoreId: 501,
				StoreName: "KNOXFIELD VIC"
			},
			{
				LookupStoreId: 502,
				StoreName: "KOTARA F/C II NSW"
			},
			{
				LookupStoreId: 503,
				StoreName: "KOTARA NSW"
			},
			{
				LookupStoreId: 504,
				StoreName: "KULUIN QLD"
			},
			{
				LookupStoreId: 505,
				StoreName: "KURRI KURRI NSW"
			},
			{
				LookupStoreId: 506,
				StoreName: "KWINANA FREEWAY NORTHBOUND WA"
			},
			{
				LookupStoreId: 507,
				StoreName: "KWINANA FREEWAY SOUTHBOUND WA"
			},
			{
				LookupStoreId: 508,
				StoreName: "KWINANA WA"
			},
			{
				LookupStoreId: 509,
				StoreName: "KARALEE QLD"
			},
			{
				LookupStoreId: 510,
				StoreName: "KEYSBOROUGH SOUTH VIC"
			},
			{
				LookupStoreId: 511,
				StoreName: "LABRADOR QLD"
			},
			{
				LookupStoreId: 512,
				StoreName: "LAKEHAVEN NSW"
			},
			{
				LookupStoreId: 513,
				StoreName: "LAKEMBA NSW"
			},
			{
				LookupStoreId: 514,
				StoreName: "LAKES ENTRANCE VIC"
			},
			{
				LookupStoreId: 515,
				StoreName: "LANDSDALE WA"
			},
			{
				LookupStoreId: 516,
				StoreName: "LANGWARRIN VIC"
			},
			{
				LookupStoreId: 517,
				StoreName: "LANSVALE NSW"
			},
			{
				LookupStoreId: 518,
				StoreName: "LARA VIC"
			},
			{
				LookupStoreId: 519,
				StoreName: "LAVERTON NORTH VIC"
			},
			{
				LookupStoreId: 520,
				StoreName: "LAVERTON VIC"
			},
			{
				LookupStoreId: 521,
				StoreName: "LAVINGTON NSW"
			},
			{
				LookupStoreId: 522,
				StoreName: "LEETON NSW"
			},
			{
				LookupStoreId: 523,
				StoreName: "LEONGATHA VIC"
			},
			{
				LookupStoreId: 524,
				StoreName: "LEOPOLD VIC"
			},
			{
				LookupStoreId: 525,
				StoreName: "LIDCOMBE NSW"
			},
			{
				LookupStoreId: 526,
				StoreName: "LILYDALE VIC"
			},
			{
				LookupStoreId: 527,
				StoreName: "LISAROW NSW"
			},
			{
				LookupStoreId: 528,
				StoreName: "LISMORE NSW"
			},
			{
				LookupStoreId: 529,
				StoreName: "LISMORE SQUARE SC NSW"
			},
			{
				LookupStoreId: 530,
				StoreName: "LITHGOW NSW"
			},
			{
				LookupStoreId: 531,
				StoreName: "LIVERPOOL F/C II NSW"
			},
			{
				LookupStoreId: 532,
				StoreName: "LIVERPOOL MEGA CENTRE NSW"
			},
			{
				LookupStoreId: 533,
				StoreName: "LIVERPOOL SOUTH NSW"
			},
			{
				LookupStoreId: 534,
				StoreName: "LIVERPOOL WEST NSW"
			},
			{
				LookupStoreId: 535,
				StoreName: "LOGAN CENTRAL QLD"
			},
			{
				LookupStoreId: 536,
				StoreName: "LOGAN HYPERDOME II QLD"
			},
			{
				LookupStoreId: 537,
				StoreName: "LOGANHOLME II QLD"
			},
			{
				LookupStoreId: 538,
				StoreName: "LOWER TEMPLESTOWE VIC"
			},
			{
				LookupStoreId: 539,
				StoreName: "LUCAS VIC"
			},
			{
				LookupStoreId: 540,
				StoreName: "LUDMILLA NT"
			},
			{
				LookupStoreId: 541,
				StoreName: "LAKELANDS WA"
			},
			{
				LookupStoreId: 542,
				StoreName: "LYNDHURST II VIC"
			},
			{
				LookupStoreId: 543,
				StoreName: "M4 EAST (CITY BOUND) NSW"
			},
			{
				LookupStoreId: 544,
				StoreName: "M4 WEST NSW"
			},
			{
				LookupStoreId: 545,
				StoreName: "MACARTHUR SQUARE II NSW"
			},
			{
				LookupStoreId: 546,
				StoreName: "MACKAY EAST QLD"
			},
			{
				LookupStoreId: 547,
				StoreName: "MACKAY FOOD COURT II QLD"
			},
			{
				LookupStoreId: 548,
				StoreName: "MACKAY NORTH QLD"
			},
			{
				LookupStoreId: 549,
				StoreName: "MACKAY NORTHERN BEACHES QLD"
			},
			{
				LookupStoreId: 550,
				StoreName: "MACKAY SOUTH OORALEA QLD"
			},
			{
				LookupStoreId: 551,
				StoreName: "MACQUARIE NSW"
			},
			{
				LookupStoreId: 552,
				StoreName: "MADDINGTON WA"
			},
			{
				LookupStoreId: 553,
				StoreName: "MAITLAND EAST NSW"
			},
			{
				LookupStoreId: 554,
				StoreName: "MAITLAND FOOD COURT II NSW"
			},
			{
				LookupStoreId: 555,
				StoreName: "MAJURA PARK ACT"
			},
			{
				LookupStoreId: 556,
				StoreName: "MALVERN EAST VIC"
			},
			{
				LookupStoreId: 557,
				StoreName: "MANDURAH FORUM SHOPPING CENTRE II WA"
			},
			{
				LookupStoreId: 558,
				StoreName: "MANDURAH GREENFIELDS WA"
			},
			{
				LookupStoreId: 559,
				StoreName: "MANOORA QLD"
			},
			{
				LookupStoreId: 560,
				StoreName: "MANOR LAKES VIC"
			},
			{
				LookupStoreId: 561,
				StoreName: "MANUKA ACT"
			},
			{
				LookupStoreId: 562,
				StoreName: "MAREEBA QLD"
			},
			{
				LookupStoreId: 563,
				StoreName: "MARINA MIRAGE QLD"
			},
			{
				LookupStoreId: 564,
				StoreName: "MAROOCHYDORE II QLD"
			},
			{
				LookupStoreId: 565,
				StoreName: "MAROUBRA NSW"
			},
			{
				LookupStoreId: 566,
				StoreName: "MARRICKVILLE METRO NSW"
			},
			{
				LookupStoreId: 567,
				StoreName: "MARSDEN PARK NSW"
			},
			{
				LookupStoreId: 568,
				StoreName: "MARSDEN QLD"
			},
			{
				LookupStoreId: 569,
				StoreName: "MARYBOROUGH QLD"
			},
			{
				LookupStoreId: 570,
				StoreName: "MARYBOROUGH VIC"
			},
			{
				LookupStoreId: 571,
				StoreName: "MAYFIELD INDUSTRIAL DRIVE NSW"
			},
			{
				LookupStoreId: 572,
				StoreName: "MAYFIELD NSW"
			},
			{
				LookupStoreId: 573,
				StoreName: "MAYLANDS WA"
			},
			{
				LookupStoreId: 574,
				StoreName: "MCWHIRTERS II QLD"
			},
			{
				LookupStoreId: 575,
				StoreName: "MEADOWBROOK QLD"
			},
			{
				LookupStoreId: 576,
				StoreName: "MELB AIRPORT II VIC"
			},
			{
				LookupStoreId: 577,
				StoreName: "MELBOURNE AIRPORT T4 VIC"
			},
			{
				LookupStoreId: 578,
				StoreName: "MELBOURNE AIRPORT VIRGIN TERMINAL VIC"
			},
			{
				LookupStoreId: 579,
				StoreName: "MELBOURNE CENTRAL II VIC"
			},
			{
				LookupStoreId: 580,
				StoreName: "MELBOURNE CENTRAL UPPER VIC"
			},
			{
				LookupStoreId: 581,
				StoreName: "MELROSE PARK SA"
			},
			{
				LookupStoreId: 582,
				StoreName: "MELTON EAST VIC"
			},
			{
				LookupStoreId: 583,
				StoreName: "MELTON VIC"
			},
			{
				LookupStoreId: 584,
				StoreName: "MELVILLE WA"
			},
			{
				LookupStoreId: 585,
				StoreName: "MENAI NSW"
			},
			{
				LookupStoreId: 586,
				StoreName: "MERIMBULA NSW"
			},
			{
				LookupStoreId: 587,
				StoreName: "MERMAID WATERS QLD"
			},
			{
				LookupStoreId: 588,
				StoreName: "MERNDA VIC"
			},
			{
				LookupStoreId: 589,
				StoreName: "MERRIMAC QLD"
			},
			{
				LookupStoreId: 590,
				StoreName: "MERRYLANDS FC II NSW"
			},
			{
				LookupStoreId: 591,
				StoreName: "MERRYLANDS NSW"
			},
			{
				LookupStoreId: 592,
				StoreName: "MIDLAND WA"
			},
			{
				LookupStoreId: 593,
				StoreName: "MIDVALE WA"
			},
			{
				LookupStoreId: 594,
				StoreName: "MILDURA VIC"
			},
			{
				LookupStoreId: 595,
				StoreName: "MILL PARK VIC"
			},
			{
				LookupStoreId: 596,
				StoreName: "MILPERRA NSW"
			},
			{
				LookupStoreId: 597,
				StoreName: "MILTON QLD"
			},
			{
				LookupStoreId: 598,
				StoreName: "MINCHINBURY NSW"
			},
			{
				LookupStoreId: 599,
				StoreName: "MINDARIE WA"
			},
			{
				LookupStoreId: 600,
				StoreName: "MINGARA NSW"
			},
			{
				LookupStoreId: 601,
				StoreName: "MINTO NSW"
			},
			{
				LookupStoreId: 602,
				StoreName: "MINYAMA QLD"
			},
			{
				LookupStoreId: 603,
				StoreName: "MIRANDA F/C LVL 1 NSW"
			},
			{
				LookupStoreId: 604,
				StoreName: "MIRRABOOKA II WA"
			},
			{
				LookupStoreId: 605,
				StoreName: "MITCHELL ACT"
			},
			{
				LookupStoreId: 606,
				StoreName: "MITTAGONG NSW"
			},
			{
				LookupStoreId: 607,
				StoreName: "MOE VIC"
			},
			{
				LookupStoreId: 608,
				StoreName: "MOONAH TAS"
			},
			{
				LookupStoreId: 609,
				StoreName: "MOOREBANK NSW"
			},
			{
				LookupStoreId: 610,
				StoreName: "MOOROOLBARK VIC"
			},
			{
				LookupStoreId: 611,
				StoreName: "MOOROOPNA VIC"
			},
			{
				LookupStoreId: 612,
				StoreName: "MORANBAH QLD"
			},
			{
				LookupStoreId: 613,
				StoreName: "MORAYFIELD QLD"
			},
			{
				LookupStoreId: 614,
				StoreName: "MOREE NSW"
			},
			{
				LookupStoreId: 615,
				StoreName: "MORISSET NSW"
			},
			{
				LookupStoreId: 616,
				StoreName: "MORLEY FOOD COURT WA"
			},
			{
				LookupStoreId: 617,
				StoreName: "MORLEY WA"
			},
			{
				LookupStoreId: 618,
				StoreName: "MORNINGTON VIC"
			},
			{
				LookupStoreId: 619,
				StoreName: "MORWELL VIC"
			},
			{
				LookupStoreId: 620,
				StoreName: "MOSS VALE NSW"
			},
			{
				LookupStoreId: 621,
				StoreName: "MOUNT ANNAN NSW"
			},
			{
				LookupStoreId: 622,
				StoreName: "MOUNT BARKER SA"
			},
			{
				LookupStoreId: 623,
				StoreName: "MOUNT DRUITT F/C NSW"
			},
			{
				LookupStoreId: 624,
				StoreName: "MOUNT DRUITT NSW"
			},
			{
				LookupStoreId: 625,
				StoreName: "MOUNT GAMBIER SA"
			},
			{
				LookupStoreId: 626,
				StoreName: "MOUNT GRAVATT QLD"
			},
			{
				LookupStoreId: 627,
				StoreName: "MOUNT ISA QLD"
			},
			{
				LookupStoreId: 628,
				StoreName: "MOUNT OMMANEY FOOD COURT QLD"
			},
			{
				LookupStoreId: 629,
				StoreName: "MOUNT WAVERLEY VIC"
			},
			{
				LookupStoreId: 630,
				StoreName: "MT COLAH NSW"
			},
			{
				LookupStoreId: 631,
				StoreName: "MUDGEE NSW"
			},
			{
				LookupStoreId: 632,
				StoreName: "MULGRAVE VIC"
			},
			{
				LookupStoreId: 633,
				StoreName: "MURRAY BRIDGE SA"
			},
			{
				LookupStoreId: 634,
				StoreName: "MURRUMBA DOWNS QLD"
			},
			{
				LookupStoreId: 635,
				StoreName: "MURWILLUMBAH NSW"
			},
			{
				LookupStoreId: 636,
				StoreName: "MUSWELLBROOK NSW"
			},
			{
				LookupStoreId: 637,
				StoreName: "MYER II QLD"
			},
			{
				LookupStoreId: 638,
				StoreName: "MALTBY BYPASS VIC"
			},
			{
				LookupStoreId: 639,
				StoreName: "MELBOURNE AIRPORT DRIVE VIC"
			},
			{
				LookupStoreId: 640,
				StoreName: "MELTON SOUTH VIC"
			},
			{
				LookupStoreId: 641,
				StoreName: "MOLONGLO VALLEY ACT"
			},
			{
				LookupStoreId: 642,
				StoreName: "MORAYFIELD EAST QLD"
			},
			{
				LookupStoreId: 643,
				StoreName: "MOUNT GAMBIER EAST SA"
			},
			{
				LookupStoreId: 644,
				StoreName: "MUNDARING WA"
			},
			{
				LookupStoreId: 645,
				StoreName: "MURDOCH WA"
			},
			{
				LookupStoreId: 646,
				StoreName: "NAMBOUR QLD"
			},
			{
				LookupStoreId: 647,
				StoreName: "NARACOORTE SA"
			},
			{
				LookupStoreId: 648,
				StoreName: "NARELLAN NSW"
			},
			{
				LookupStoreId: 649,
				StoreName: "NARELLAN TOWN CENTRE II NSW"
			},
			{
				LookupStoreId: 650,
				StoreName: "NARRABRI NSW"
			},
			{
				LookupStoreId: 651,
				StoreName: "NEETA CITY II NSW"
			},
			{
				LookupStoreId: 652,
				StoreName: "NERANG QLD"
			},
			{
				LookupStoreId: 653,
				StoreName: "NEW NORFOLK TAS"
			},
			{
				LookupStoreId: 654,
				StoreName: "NEWCOMB VIC"
			},
			{
				LookupStoreId: 655,
				StoreName: "NEWMARKET II QLD"
			},
			{
				LookupStoreId: 656,
				StoreName: "NIDDRIE VIC"
			},
			{
				LookupStoreId: 657,
				StoreName: "NOARLUNGA SA"
			},
			{
				LookupStoreId: 658,
				StoreName: "NOBLE PARK VIC"
			},
			{
				LookupStoreId: 659,
				StoreName: "NOOSAVILLE QLD"
			},
			{
				LookupStoreId: 660,
				StoreName: "NORTH HOBART TAS"
			},
			{
				LookupStoreId: 661,
				StoreName: "NORTH LAKES QLD"
			},
			{
				LookupStoreId: 662,
				StoreName: "NORTH LAKES WESTFIELD QLD"
			},
			{
				LookupStoreId: 663,
				StoreName: "NORTH PERTH WA"
			},
			{
				LookupStoreId: 664,
				StoreName: "NORTH RYDE NSW"
			},
			{
				LookupStoreId: 665,
				StoreName: "NORTH WARD QLD"
			},
			{
				LookupStoreId: 666,
				StoreName: "NORTHAM WA"
			},
			{
				LookupStoreId: 667,
				StoreName: "NORTHBRIDGE WA"
			},
			{
				LookupStoreId: 668,
				StoreName: "NORTHLAND SHOPPING CENTRE II VIC"
			},
			{
				LookupStoreId: 669,
				StoreName: "NORTHLAND VIC"
			},
			{
				LookupStoreId: 670,
				StoreName: "NORTHMEAD NSW"
			},
			{
				LookupStoreId: 671,
				StoreName: "NORWEST MARKETOWN NSW"
			},
			{
				LookupStoreId: 672,
				StoreName: "NOWRA CENTRAL NSW"
			},
			{
				LookupStoreId: 673,
				StoreName: "NUDGEE SERVICE CENTRE QLD"
			},
			{
				LookupStoreId: 674,
				StoreName: "NUNAWADING II VIC"
			},
			{
				LookupStoreId: 675,
				StoreName: "NAMBUCCA HIGHWAY SERVICE CENTRE NSW"
			},
			{
				LookupStoreId: 676,
				StoreName: "NORTH LAKES BUSINESS PARK QLD"
			},
			{
				LookupStoreId: 677,
				StoreName: "NORTHFIELD SA"
			},
			{
				LookupStoreId: 678,
				StoreName: "NORWEST II NSW"
			},
			{
				LookupStoreId: 679,
				StoreName: "O'CONNOR WA"
			},
			{
				LookupStoreId: 680,
				StoreName: "OAK PARK VIC"
			},
			{
				LookupStoreId: 681,
				StoreName: "OAKLEIGH VIC"
			},
			{
				LookupStoreId: 682,
				StoreName: "OFFICER VIC"
			},
			{
				LookupStoreId: 683,
				StoreName: "OLYMPIC BOULEVARD NSW"
			},
			{
				LookupStoreId: 684,
				StoreName: "ORANGE NORTH NSW"
			},
			{
				LookupStoreId: 685,
				StoreName: "ORANGE NSW"
			},
			{
				LookupStoreId: 686,
				StoreName: "ORMEAU QLD"
			},
			{
				LookupStoreId: 687,
				StoreName: "ORMOND VIC"
			},
			{
				LookupStoreId: 688,
				StoreName: "OXENFORD QLD"
			},
			{
				LookupStoreId: 689,
				StoreName: "OXLEY QLD"
			},
			{
				LookupStoreId: 690,
				StoreName: "OCEAN GROVE VIC"
			},
			{
				LookupStoreId: 691,
				StoreName: "PACIFIC FAIR QLD"
			},
			{
				LookupStoreId: 692,
				StoreName: "PACIFIC PINES QLD"
			},
			{
				LookupStoreId: 693,
				StoreName: "PADSTOW NSW"
			},
			{
				LookupStoreId: 694,
				StoreName: "PAKENHAM BYPASS INBOUND VIC"
			},
			{
				LookupStoreId: 695,
				StoreName: "PAKENHAM BYPASS OUTBOUND VIC"
			},
			{
				LookupStoreId: 696,
				StoreName: "PAKENHAM VIC"
			},
			{
				LookupStoreId: 697,
				StoreName: "PALM BEACH QLD"
			},
			{
				LookupStoreId: 698,
				StoreName: "PALMERSTON NT"
			},
			{
				LookupStoreId: 699,
				StoreName: "PARA HILLS SA"
			},
			{
				LookupStoreId: 700,
				StoreName: "PARALOWIE SA"
			},
			{
				LookupStoreId: 701,
				StoreName: "PARK RIDGE QLD"
			},
			{
				LookupStoreId: 702,
				StoreName: "PARKES NSW"
			},
			{
				LookupStoreId: 703,
				StoreName: "PARKMORE SHOPPING CENTRE VIC"
			},
			{
				LookupStoreId: 704,
				StoreName: "PARRAMATTA NORTH NSW"
			},
			{
				LookupStoreId: 705,
				StoreName: "PARRAMATTA W/F L1 NSW"
			},
			{
				LookupStoreId: 706,
				StoreName: "PASCOE VALE SOUTH VIC"
			},
			{
				LookupStoreId: 707,
				StoreName: "PENINSULA FAIR QLD"
			},
			{
				LookupStoreId: 708,
				StoreName: "PENINSULA LINK NORTHBOUND VIC"
			},
			{
				LookupStoreId: 709,
				StoreName: "PENINSULA LINK SOUTHBOUND VIC"
			},
			{
				LookupStoreId: 710,
				StoreName: "PENRITH LEAGUES NSW"
			},
			{
				LookupStoreId: 711,
				StoreName: "PENRITH NORTH NSW"
			},
			{
				LookupStoreId: 712,
				StoreName: "PENRITH NSW"
			},
			{
				LookupStoreId: 713,
				StoreName: "PENRITH PLAZA II NSW"
			},
			{
				LookupStoreId: 714,
				StoreName: "PICTON NSW"
			},
			{
				LookupStoreId: 715,
				StoreName: "PIMPAMA QLD"
			},
			{
				LookupStoreId: 716,
				StoreName: "PLENTY VALLEY S/C VIC"
			},
			{
				LookupStoreId: 717,
				StoreName: "PLUMPTON NSW"
			},
			{
				LookupStoreId: 718,
				StoreName: "POINT COOK NORTH VIC"
			},
			{
				LookupStoreId: 719,
				StoreName: "POINT COOK VIC"
			},
			{
				LookupStoreId: 720,
				StoreName: "POORAKA SA"
			},
			{
				LookupStoreId: 721,
				StoreName: "PORT ADELAIDE SA"
			},
			{
				LookupStoreId: 722,
				StoreName: "PORT AUGUSTA SA"
			},
			{
				LookupStoreId: 723,
				StoreName: "PORT HEDLAND WA"
			},
			{
				LookupStoreId: 724,
				StoreName: "PORT LINCOLN SA"
			},
			{
				LookupStoreId: 725,
				StoreName: "PORT MACQUARIE HIGHWAY NSW"
			},
			{
				LookupStoreId: 726,
				StoreName: "PORT MACQUARIE NSW"
			},
			{
				LookupStoreId: 727,
				StoreName: "PORT PIRIE SA"
			},
			{
				LookupStoreId: 728,
				StoreName: "PORTLAND VIC"
			},
			{
				LookupStoreId: 729,
				StoreName: "PRAHRAN VIC"
			},
			{
				LookupStoreId: 730,
				StoreName: "PRAIRIEWOOD FOODCOURT NSW"
			},
			{
				LookupStoreId: 731,
				StoreName: "PRAIRIEWOOD NSW"
			},
			{
				LookupStoreId: 732,
				StoreName: "PRESTON II VIC"
			},
			{
				LookupStoreId: 733,
				StoreName: "PRESTONS NSW"
			},
			{
				LookupStoreId: 734,
				StoreName: "PROSPECT SA"
			},
			{
				LookupStoreId: 735,
				StoreName: "PUNCHBOWL NSW"
			},
			{
				LookupStoreId: 736,
				StoreName: "PAKENHAM SOUTH VIC"
			},
			{
				LookupStoreId: 737,
				StoreName: "PLAINLAND QLD"
			},
			{
				LookupStoreId: 738,
				StoreName: "PLAZA METRO GEORGE ST NSW"
			},
			{
				LookupStoreId: 739,
				StoreName: "PUMICESTONE QLD"
			},
			{
				LookupStoreId: 740,
				StoreName: "QUAKERS HILL NSW"
			},
			{
				LookupStoreId: 741,
				StoreName: "QUEANBEYAN NSW"
			},
			{
				LookupStoreId: 742,
				StoreName: "QUEEN STREET QLD"
			},
			{
				LookupStoreId: 743,
				StoreName: "RAYMOND TERRACE NSW"
			},
			{
				LookupStoreId: 744,
				StoreName: "REDBANK PLAZA QLD"
			},
			{
				LookupStoreId: 745,
				StoreName: "REDCLIFFE QLD"
			},
			{
				LookupStoreId: 746,
				StoreName: "REDLYNCH QLD"
			},
			{
				LookupStoreId: 747,
				StoreName: "REEDY CREEK QLD"
			},
			{
				LookupStoreId: 748,
				StoreName: "RENMARK SA"
			},
			{
				LookupStoreId: 749,
				StoreName: "REVESBY NSW"
			},
			{
				LookupStoreId: 750,
				StoreName: "REYNELLA SA"
			},
			{
				LookupStoreId: 751,
				StoreName: "RICHLANDS QLD"
			},
			{
				LookupStoreId: 752,
				StoreName: "RICHMOND NSW"
			},
			{
				LookupStoreId: 753,
				StoreName: "RICHMOND VIC"
			},
			{
				LookupStoreId: 754,
				StoreName: "RINGWOOD VIC"
			},
			{
				LookupStoreId: 755,
				StoreName: "RIVERDALE VILLAGE VIC"
			},
			{
				LookupStoreId: 756,
				StoreName: "RIVERTON WA"
			},
			{
				LookupStoreId: 757,
				StoreName: "ROBINA CENTRAL QLD"
			},
			{
				LookupStoreId: 758,
				StoreName: "ROBINA FC II QLD"
			},
			{
				LookupStoreId: 759,
				StoreName: "ROCKBANK INBOUND VIC"
			},
			{
				LookupStoreId: 760,
				StoreName: "ROCKBANK OUTBOUND VIC"
			},
			{
				LookupStoreId: 761,
				StoreName: "ROCKDALE NSW"
			},
			{
				LookupStoreId: 762,
				StoreName: "ROCKDALE PLAZA NSW"
			},
			{
				LookupStoreId: 763,
				StoreName: "ROCKHAMPTON NORTH QLD"
			},
			{
				LookupStoreId: 764,
				StoreName: "ROCKHAMPTON QLD"
			},
			{
				LookupStoreId: 765,
				StoreName: "ROCKHAMPTON STOCKLAND FC QLD"
			},
			{
				LookupStoreId: 766,
				StoreName: "ROCKINGHAM WA"
			},
			{
				LookupStoreId: 767,
				StoreName: "ROCKLEA QLD"
			},
			{
				LookupStoreId: 768,
				StoreName: "ROMA QLD"
			},
			{
				LookupStoreId: 769,
				StoreName: "ROSEBUD VIC"
			},
			{
				LookupStoreId: 770,
				StoreName: "ROSEHILL NSW"
			},
			{
				LookupStoreId: 771,
				StoreName: "ROSEMEADOW NSW"
			},
			{
				LookupStoreId: 772,
				StoreName: "ROSNY PARK TAS"
			},
			{
				LookupStoreId: 773,
				StoreName: "ROUSE HILL NSW"
			},
			{
				LookupStoreId: 774,
				StoreName: "ROUSE HILL TOWN CENTRE NSW"
			},
			{
				LookupStoreId: 775,
				StoreName: "ROWVILLE VIC"
			},
			{
				LookupStoreId: 776,
				StoreName: "ROXBURGH PARK VIC"
			},
			{
				LookupStoreId: 777,
				StoreName: "RUNAWAY BAY S/C QLD"
			},
			{
				LookupStoreId: 778,
				StoreName: "RUNDLE MALL EAST SA"
			},
			{
				LookupStoreId: 779,
				StoreName: "RUTHERFORD NSW"
			},
			{
				LookupStoreId: 780,
				StoreName: "RYDALMERE NSW"
			},
			{
				LookupStoreId: 781,
				StoreName: "RANDWICK II NSW"
			},
			{
				LookupStoreId: 782,
				StoreName: "RHODES NSW"
			},
			{
				LookupStoreId: 783,
				StoreName: "RIPLEY QLD"
			},
			{
				LookupStoreId: 784,
				StoreName: "ROCHEDALE QLD"
			},
			{
				LookupStoreId: 785,
				StoreName: "SALAMANDER BAY NSW"
			},
			{
				LookupStoreId: 786,
				StoreName: "SALE VIC"
			},
			{
				LookupStoreId: 787,
				StoreName: "SALISBURY QLD"
			},
			{
				LookupStoreId: 788,
				StoreName: "SALISBURY SA"
			},
			{
				LookupStoreId: 789,
				StoreName: "SANDGATE QLD"
			},
			{
				LookupStoreId: 790,
				StoreName: "SANDOWN VIC"
			},
			{
				LookupStoreId: 791,
				StoreName: "SANDY BAY TAS"
			},
			{
				LookupStoreId: 792,
				StoreName: "SANS SOUCI NSW"
			},
			{
				LookupStoreId: 793,
				StoreName: "SCONE NSW"
			},
			{
				LookupStoreId: 794,
				StoreName: "SEAFORD SA"
			},
			{
				LookupStoreId: 795,
				StoreName: "SEBASTOPOL VIC"
			},
			{
				LookupStoreId: 796,
				StoreName: "SECRET HARBOUR WA"
			},
			{
				LookupStoreId: 797,
				StoreName: "SEVEN HILLS CENTRE NSW"
			},
			{
				LookupStoreId: 798,
				StoreName: "SEVEN HILLS NORTH NSW"
			},
			{
				LookupStoreId: 799,
				StoreName: "SEYMOUR VIC"
			},
			{
				LookupStoreId: 800,
				StoreName: "SHELLHARBOUR STOCKLAND FOOD COURT NSW"
			},
			{
				LookupStoreId: 801,
				StoreName: "SHEPPARTON NORTH VIC"
			},
			{
				LookupStoreId: 802,
				StoreName: "SHEPPARTON VIC"
			},
			{
				LookupStoreId: 803,
				StoreName: "SINGLETON NSW"
			},
			{
				LookupStoreId: 804,
				StoreName: "SIPPY DOWNS QLD"
			},
			{
				LookupStoreId: 805,
				StoreName: "SKYE VIC"
			},
			{
				LookupStoreId: 806,
				StoreName: "SMITHFIELD II QLD"
			},
			{
				LookupStoreId: 807,
				StoreName: "SMITHFIELD NSW"
			},
			{
				LookupStoreId: 808,
				StoreName: "SMITHFIELD SA"
			},
			{
				LookupStoreId: 809,
				StoreName: "SOMERVILLE VIC"
			},
			{
				LookupStoreId: 810,
				StoreName: "SORELL TAS"
			},
			{
				LookupStoreId: 811,
				StoreName: "SOUTH LAUNCESTON TAS"
			},
			{
				LookupStoreId: 812,
				StoreName: "SOUTH MELBOURNE VIC"
			},
			{
				LookupStoreId: 813,
				StoreName: "SOUTH NOWRA NSW"
			},
			{
				LookupStoreId: 814,
				StoreName: "SOUTH OAKLEIGH VIC"
			},
			{
				LookupStoreId: 815,
				StoreName: "SOUTH PERTH WA"
			},
			{
				LookupStoreId: 816,
				StoreName: "SOUTHLAND FOODCOURT VIC"
			},
			{
				LookupStoreId: 817,
				StoreName: "SOUTHLAND VIC"
			},
			{
				LookupStoreId: 818,
				StoreName: "SOUTHPORT II QLD"
			},
			{
				LookupStoreId: 819,
				StoreName: "SPEARWOOD WA"
			},
			{
				LookupStoreId: 820,
				StoreName: "SPRING FARM NSW"
			},
			{
				LookupStoreId: 821,
				StoreName: "SPRINGFIELD LAKES QLD"
			},
			{
				LookupStoreId: 822,
				StoreName: "SPRINGFIELD ORION F/C QLD"
			},
			{
				LookupStoreId: 823,
				StoreName: "SPRINGVALE VIC"
			},
			{
				LookupStoreId: 824,
				StoreName: "SPRINGWOOD QLD"
			},
			{
				LookupStoreId: 825,
				StoreName: "ST ALBANS VIC"
			},
			{
				LookupStoreId: 826,
				StoreName: "ST CLAIR NSW"
			},
			{
				LookupStoreId: 827,
				StoreName: "ST IVES NSW"
			},
			{
				LookupStoreId: 828,
				StoreName: "ST KILDA ROAD VIC"
			},
			{
				LookupStoreId: 829,
				StoreName: "ST KILDA VIC"
			},
			{
				LookupStoreId: 830,
				StoreName: "ST LEONARDS NSW"
			},
			{
				LookupStoreId: 831,
				StoreName: "ST MARYS NORTH NSW"
			},
			{
				LookupStoreId: 832,
				StoreName: "ST MARYS SOUTH NSW"
			},
			{
				LookupStoreId: 833,
				StoreName: "ST MARYS VILLAGE NSW"
			},
			{
				LookupStoreId: 834,
				StoreName: "ST PETERS NSW"
			},
			{
				LookupStoreId: 835,
				StoreName: "STAFFORD QLD"
			},
			{
				LookupStoreId: 836,
				StoreName: "STANMORE NSW"
			},
			{
				LookupStoreId: 837,
				StoreName: "STANTHORPE QLD"
			},
			{
				LookupStoreId: 838,
				StoreName: "STAWELL VIC"
			},
			{
				LookupStoreId: 839,
				StoreName: "STRATH VILLAGE VIC"
			},
			{
				LookupStoreId: 840,
				StoreName: "STRATHPINE II QLD"
			},
			{
				LookupStoreId: 841,
				StoreName: "STUART PARK NT"
			},
			{
				LookupStoreId: 842,
				StoreName: "SUNBURY VIC"
			},
			{
				LookupStoreId: 843,
				StoreName: "SUNNYBANK QLD"
			},
			{
				LookupStoreId: 844,
				StoreName: "SUNSHINE MARKET PLACE VIC"
			},
			{
				LookupStoreId: 845,
				StoreName: "SUNSHINE PLAZA QLD"
			},
			{
				LookupStoreId: 846,
				StoreName: "SUNSHINE VIC"
			},
			{
				LookupStoreId: 847,
				StoreName: "SUTTON FOREST NSW"
			},
			{
				LookupStoreId: 848,
				StoreName: "SUTTON FOREST SOUTHBOUND NSW"
			},
			{
				LookupStoreId: 849,
				StoreName: "SWAN HILL VIC"
			},
			{
				LookupStoreId: 850,
				StoreName: "SWANSEA NSW"
			},
			{
				LookupStoreId: 851,
				StoreName: "SWANSTON & LONSDALE VIC"
			},
			{
				LookupStoreId: 852,
				StoreName: "SYDENHAM VIC"
			},
			{
				LookupStoreId: 853,
				StoreName: "SYDNEY AIRPORT - GATEWAY NSW"
			},
			{
				LookupStoreId: 854,
				StoreName: "SYDNEY DOMESTIC TERMINAL II NSW"
			},
			{
				LookupStoreId: 855,
				StoreName: "SYDNEY GATEWAY NSW"
			},
			{
				LookupStoreId: 856,
				StoreName: "SYLVANIA NSW"
			},
			{
				LookupStoreId: 857,
				StoreName: "SALISBURY PLAINS SA"
			},
			{
				LookupStoreId: 858,
				StoreName: "SOUTHBANK QLD"
			},
			{
				LookupStoreId: 859,
				StoreName: "SPENCER STREET VIC"
			},
			{
				LookupStoreId: 860,
				StoreName: "STRATHPINE TOWN CENTRE QLD"
			},
			{
				LookupStoreId: 861,
				StoreName: "SYDNEY CENTRAL WESTFIELD PLAZA NSW"
			},
			{
				LookupStoreId: 862,
				StoreName: "TAMWORTH NSW"
			},
			{
				LookupStoreId: 863,
				StoreName: "TAMWORTH SOUTH NSW"
			},
			{
				LookupStoreId: 864,
				StoreName: "TAMWORTH WEST NSW"
			},
			{
				LookupStoreId: 865,
				StoreName: "TAREE NSW"
			},
			{
				LookupStoreId: 866,
				StoreName: "TAREE SOUTH SERVICE CENTRE NSW"
			},
			{
				LookupStoreId: 867,
				StoreName: "TAREN POINT NSW"
			},
			{
				LookupStoreId: 868,
				StoreName: "TARNEIT VIC"
			},
			{
				LookupStoreId: 869,
				StoreName: "TAYLORS LAKES VIC"
			},
			{
				LookupStoreId: 870,
				StoreName: "TEA TREE PLAZA II SA"
			},
			{
				LookupStoreId: 871,
				StoreName: "TEA TREE WESTFIELD FOOD COURT SA"
			},
			{
				LookupStoreId: 872,
				StoreName: "TECOMA VIC"
			},
			{
				LookupStoreId: 873,
				StoreName: "TEMORA NSW"
			},
			{
				LookupStoreId: 874,
				StoreName: "THE GAP QLD"
			},
			{
				LookupStoreId: 875,
				StoreName: "THOMASTOWN II VIC"
			},
			{
				LookupStoreId: 876,
				StoreName: "THOMSONS LAKE WA"
			},
			{
				LookupStoreId: 877,
				StoreName: "THORNLEIGH NSW"
			},
			{
				LookupStoreId: 878,
				StoreName: "THORNTON NSW"
			},
			{
				LookupStoreId: 879,
				StoreName: "TINGALPA QLD"
			},
			{
				LookupStoreId: 880,
				StoreName: "TOOMBUL II QLD"
			},
			{
				LookupStoreId: 881,
				StoreName: "TOOWOOMBA EAST QLD"
			},
			{
				LookupStoreId: 882,
				StoreName: "TOOWOOMBA QLD"
			},
			{
				LookupStoreId: 883,
				StoreName: "TOOWOOMBA SOUTH QLD"
			},
			{
				LookupStoreId: 884,
				StoreName: "TOOWOOMBA WEST QLD"
			},
			{
				LookupStoreId: 885,
				StoreName: "TORONTO NSW"
			},
			{
				LookupStoreId: 886,
				StoreName: "TORQUAY VIC"
			},
			{
				LookupStoreId: 887,
				StoreName: "TOWERHILL VIC"
			},
			{
				LookupStoreId: 888,
				StoreName: "TOWNSVILLE CBD QLD"
			},
			{
				LookupStoreId: 889,
				StoreName: "TOWNSVILLE LAKES QLD"
			},
			{
				LookupStoreId: 890,
				StoreName: "TOWNSVILLE NORTHSHORE QLD"
			},
			{
				LookupStoreId: 891,
				StoreName: "TOWNSVILLE RASMUSSEN QLD"
			},
			{
				LookupStoreId: 892,
				StoreName: "TOWNSVILLE STOCKLAND QLD"
			},
			{
				LookupStoreId: 893,
				StoreName: "TOWNSVILLE THURINGOWA QLD"
			},
			{
				LookupStoreId: 894,
				StoreName: "TOWNSVILLE WILLOWS QLD"
			},
			{
				LookupStoreId: 895,
				StoreName: "TRARALGON EAST VIC"
			},
			{
				LookupStoreId: 896,
				StoreName: "TRARALGON VIC"
			},
			{
				LookupStoreId: 897,
				StoreName: "TREENDALE WA"
			},
			{
				LookupStoreId: 898,
				StoreName: "TRINITY GARDENS SA"
			},
			{
				LookupStoreId: 899,
				StoreName: "TUART HILL WA"
			},
			{
				LookupStoreId: 900,
				StoreName: "TUGGERAH FOOD COURT NSW"
			},
			{
				LookupStoreId: 901,
				StoreName: "TUGGERANONG ACT"
			},
			{
				LookupStoreId: 902,
				StoreName: "TUGUN QLD"
			},
			{
				LookupStoreId: 903,
				StoreName: "TULLAMARINE VIC"
			},
			{
				LookupStoreId: 904,
				StoreName: "TUMUT NSW"
			},
			{
				LookupStoreId: 905,
				StoreName: "TWEED CITY F/C II QLD"
			},
			{
				LookupStoreId: 906,
				StoreName: "TWEED HEADS SOUTH NSW"
			},
			{
				LookupStoreId: 907,
				StoreName: "TAHMOOR NSW"
			},
			{
				LookupStoreId: 908,
				StoreName: "TAPPING WA"
			},
			{
				LookupStoreId: 909,
				StoreName: "THE STRAND ARCADE NSW"
			},
			{
				LookupStoreId: 910,
				StoreName: "TRAVESTON SERVICE CENTRE QLD"
			},
			{
				LookupStoreId: 911,
				StoreName: "ULLADULLA NSW"
			},
			{
				LookupStoreId: 912,
				StoreName: "ULVERSTONE TAS"
			},
			{
				LookupStoreId: 913,
				StoreName: "UMINA NSW"
			},
			{
				LookupStoreId: 914,
				StoreName: "UNDERWOOD QLD"
			},
			{
				LookupStoreId: 915,
				StoreName: "UPPER COOMERA QLD"
			},
			{
				LookupStoreId: 916,
				StoreName: "URANGAN QLD"
			},
			{
				LookupStoreId: 917,
				StoreName: "UNANDERRA NSW"
			},
			{
				LookupStoreId: 918,
				StoreName: "VERMONT SOUTH VIC"
			},
			{
				LookupStoreId: 919,
				StoreName: "VICTOR HARBOR SA"
			},
			{
				LookupStoreId: 920,
				StoreName: "VICTORIA GARDENS VIC"
			},
			{
				LookupStoreId: 921,
				StoreName: "VICTORIA MARKETS VIC"
			},
			{
				LookupStoreId: 922,
				StoreName: "VICTORIA POINT QLD"
			},
			{
				LookupStoreId: 923,
				StoreName: "VILLAWOOD II NSW"
			},
			{
				LookupStoreId: 924,
				StoreName: "VIRGINIA QLD"
			},
			{
				LookupStoreId: 925,
				StoreName: "VASSE WA"
			},
			{
				LookupStoreId: 926,
				StoreName: "WADALBA NSW"
			},
			{
				LookupStoreId: 927,
				StoreName: "WAGGA EAST NSW"
			},
			{
				LookupStoreId: 928,
				StoreName: "WAGGA GLENFIELD NSW"
			},
			{
				LookupStoreId: 929,
				StoreName: "WAGGA KOORINGAL NSW"
			},
			{
				LookupStoreId: 930,
				StoreName: "WAGGA WAGGA NSW"
			},
			{
				LookupStoreId: 931,
				StoreName: "WAITARA NSW"
			},
			{
				LookupStoreId: 932,
				StoreName: "WALLAN NTH VIC"
			},
			{
				LookupStoreId: 933,
				StoreName: "WALLAN STH VIC"
			},
			{
				LookupStoreId: 934,
				StoreName: "WALLSEND NSW"
			},
			{
				LookupStoreId: 935,
				StoreName: "WANGARATTA VIC"
			},
			{
				LookupStoreId: 936,
				StoreName: "WANNEROO WA"
			},
			{
				LookupStoreId: 937,
				StoreName: "WANTIRNA VIC"
			},
			{
				LookupStoreId: 938,
				StoreName: "WARILLA NSW"
			},
			{
				LookupStoreId: 939,
				StoreName: "WARNBRO WA"
			},
			{
				LookupStoreId: 940,
				StoreName: "WARNER QLD"
			},
			{
				LookupStoreId: 941,
				StoreName: "WARNERS BAY NSW"
			},
			{
				LookupStoreId: 942,
				StoreName: "WARRAGUL VIC"
			},
			{
				LookupStoreId: 943,
				StoreName: "WARRALILY VIC"
			},
			{
				LookupStoreId: 944,
				StoreName: "WARRAWONG II NSW"
			},
			{
				LookupStoreId: 945,
				StoreName: "WARRIEWOOD NSW"
			},
			{
				LookupStoreId: 946,
				StoreName: "WARRINGAH MALL F/C NSW"
			},
			{
				LookupStoreId: 947,
				StoreName: "WARRNAMBOOL CENTRAL VIC"
			},
			{
				LookupStoreId: 948,
				StoreName: "WARRNAMBOOL EAST VIC"
			},
			{
				LookupStoreId: 949,
				StoreName: "WARWICK ENTERTAINMENT CENTRE WA"
			},
			{
				LookupStoreId: 950,
				StoreName: "WARWICK QLD"
			},
			{
				LookupStoreId: 951,
				StoreName: "WATERGARDENS VIC"
			},
			{
				LookupStoreId: 952,
				StoreName: "WATERLOO NSW"
			},
			{
				LookupStoreId: 953,
				StoreName: "WAURN PONDS VIC"
			},
			{
				LookupStoreId: 954,
				StoreName: "WAVERLEY GARDENS II VIC"
			},
			{
				LookupStoreId: 955,
				StoreName: "WELLINGTON NSW"
			},
			{
				LookupStoreId: 956,
				StoreName: "WENDOUREE VIC"
			},
			{
				LookupStoreId: 957,
				StoreName: "WENTWORTHVILLE NSW"
			},
			{
				LookupStoreId: 958,
				StoreName: "WERRIBEE PLAZA VIC"
			},
			{
				LookupStoreId: 959,
				StoreName: "WERRIBEE VIC"
			},
			{
				LookupStoreId: 960,
				StoreName: "WERRINGTON NSW"
			},
			{
				LookupStoreId: 961,
				StoreName: "WEST BEACH SA"
			},
			{
				LookupStoreId: 962,
				StoreName: "WEST RYDE BP NSW"
			},
			{
				LookupStoreId: 963,
				StoreName: "WEST RYDE NSW"
			},
			{
				LookupStoreId: 964,
				StoreName: "WEST TERRACE SA"
			},
			{
				LookupStoreId: 965,
				StoreName: "WESTERN RING RD EAST VIC"
			},
			{
				LookupStoreId: 966,
				StoreName: "WESTERN RING RD WEST VIC"
			},
			{
				LookupStoreId: 967,
				StoreName: "WESTLAKES SA"
			},
			{
				LookupStoreId: 968,
				StoreName: "WESTMEAD NSW"
			},
			{
				LookupStoreId: 969,
				StoreName: "WESTON ACT"
			},
			{
				LookupStoreId: 970,
				StoreName: "WETHERILL PARK NSW"
			},
			{
				LookupStoreId: 971,
				StoreName: "WHITFORD CITY WA"
			},
			{
				LookupStoreId: 972,
				StoreName: "WHITTLESEA VIC"
			},
			{
				LookupStoreId: 973,
				StoreName: "WHYALLA SA"
			},
			{
				LookupStoreId: 974,
				StoreName: "WILLETTON WA"
			},
			{
				LookupStoreId: 975,
				StoreName: "WILLIAM STREET WA"
			},
			{
				LookupStoreId: 976,
				StoreName: "WILLIAMTOWN NSW"
			},
			{
				LookupStoreId: 977,
				StoreName: "WINDSOR NSW"
			},
			{
				LookupStoreId: 978,
				StoreName: "WINDSOR WEST QLD"
			},
			{
				LookupStoreId: 979,
				StoreName: "WINTERGARDEN II QLD"
			},
			{
				LookupStoreId: 980,
				StoreName: "WISHART QLD"
			},
			{
				LookupStoreId: 981,
				StoreName: "WODEN ACT"
			},
			{
				LookupStoreId: 982,
				StoreName: "WODONGA HOMEMAKER CENTRE VIC"
			},
			{
				LookupStoreId: 983,
				StoreName: "WODONGA VIC"
			},
			{
				LookupStoreId: 984,
				StoreName: "WOLLERT VIC"
			},
			{
				LookupStoreId: 985,
				StoreName: "WOLLONGONG NSW"
			},
			{
				LookupStoreId: 986,
				StoreName: "WONTHAGGI VIC"
			},
			{
				LookupStoreId: 987,
				StoreName: "WOODBINE NSW"
			},
			{
				LookupStoreId: 988,
				StoreName: "WOODBRIDGE WA"
			},
			{
				LookupStoreId: 989,
				StoreName: "WOONONA NSW"
			},
			{
				LookupStoreId: 990,
				StoreName: "WOY WOY NSW"
			},
			{
				LookupStoreId: 991,
				StoreName: "WYNDHAM WATERS VIC"
			},
			{
				LookupStoreId: 992,
				StoreName: "WYNNUM WEST QLD"
			},
			{
				LookupStoreId: 993,
				StoreName: "WYOMING NSW"
			},
			{
				LookupStoreId: 994,
				StoreName: "WYONG NSW"
			},
			{
				LookupStoreId: 995,
				StoreName: "WALLAN VICTORIA VIC"
			},
			{
				LookupStoreId: 996,
				StoreName: "WEST RICHMOND SA"
			},
			{
				LookupStoreId: 997,
				StoreName: "WESTBROOK QLD"
			},
			{
				LookupStoreId: 998,
				StoreName: "WOLLONGONG FOOD COURT NSW"
			},
			{
				LookupStoreId: 999,
				StoreName: "WOODVILLE SA"
			},
			{
				LookupStoreId: 1000,
				StoreName: "WYNYARD RAILWAY NSW"
			},
			{
				LookupStoreId: 1001,
				StoreName: "YALLAMBIE VIC"
			},
			{
				LookupStoreId: 1002,
				StoreName: "YAMANTO QLD"
			},
			{
				LookupStoreId: 1003,
				StoreName: "YAMBA NSW"
			},
			{
				LookupStoreId: 1004,
				StoreName: "YANCHEP WA"
			},
			{
				LookupStoreId: 1005,
				StoreName: "YARRAVILLE II VIC"
			},
			{
				LookupStoreId: 1006,
				StoreName: "YARRAWONGA VIC"
			},
			{
				LookupStoreId: 1007,
				StoreName: "YASS NSW"
			},
			{
				LookupStoreId: 1008,
				StoreName: "YEPPOON QLD"
			},
			{
				LookupStoreId: 1009,
				StoreName: "YOUNG NSW"
			},
			{
				LookupStoreId: 1010,
				StoreName: "YARRABILBA QLD"
			},
			{
				LookupStoreId: 1011,
				StoreName: "KNOX CITY VIC - CLOSED"
			},
			{
				LookupStoreId: 1012,
				StoreName: "MANLY WHARF SHOPPING CENTRE NSW - CLOSED"
			},
			{
				LookupStoreId: 1013,
				StoreName: "CROWN CASINO II VIC - CLOSED"
			},
			{
				LookupStoreId: 1014,
				StoreName: "MOOLOOLABA QLD - CLOSED"
			},
			{
				LookupStoreId: 1015,
				StoreName: "CROWN CASINO VIC - CLOSED"
			},
			{
				LookupStoreId: 1016,
				StoreName: "CASTLETOWN QLD - CLOSED"
			},
			{
				LookupStoreId: 1017,
				StoreName: "COLLINS STREET EAST VIC - CLOSED"
			},
			{
				LookupStoreId: 1018,
				StoreName: "SYDNEY CBD NSW - CLOSED"
			},
			{
				LookupStoreId: 1019,
				StoreName: "ROYAL CHILDRENS HOSPITAL VIC  - CLOSED"
			},
			{
				LookupStoreId: 1020,
				StoreName: "ROYAL CHILDRENS HOSPITAL II VIC - CLOSED"
			},
			{
				LookupStoreId: 1021,
				StoreName: "CRANBOURNE EXPRESS VIC - CLOSED"
			},
			{
				LookupStoreId: 1022,
				StoreName: "INDUSTRIAL NSW - CLOSED"
			},
			{
				LookupStoreId: 1023,
				StoreName: "BRISBANE TRANSIT CENTRE - CLOSED"
			},
			{
				LookupStoreId: 1024,
				StoreName: "NORTHGATE TAS - CLOSED"
			},
			{
				LookupStoreId: 1025,
				StoreName: "MYER CENTRE QLD - CLOSED"
			},
			{
				LookupStoreId: 1026,
				StoreName: "BANKSTOWN LEVEL 2 - CLOSED "
			},
			{
				LookupStoreId: 1027,
				StoreName: "BROARDMEADOW II NSW - CLOSED"
			},
			{
				LookupStoreId: 1028,
				StoreName: "FRANKSTON BAYSIDE VIC - CLOSED"
			},
			{
				LookupStoreId: 1029,
				StoreName: "TOOWONG VILLAGE QLD - CLOSED"
			},
			{
				LookupStoreId: 1030,
				StoreName: "CRONULLA NSW - CLOSED"
			},
			{
				LookupStoreId: 1031,
				StoreName: "BOORAGOON WA - CLOSED"
			},
			{
				LookupStoreId: 1032,
				StoreName: "BRAYBROOK VIC - CLOSED"
			},
			{
				LookupStoreId: 1033,
				StoreName: "MUNRO NSW - CLOSED"
			},
			{
				LookupStoreId: 1034,
				StoreName: "KINGSWAY WA - CLOSED"
			},
			{
				LookupStoreId: 1035,
				StoreName: "CAMPSIE NSW - CLOSED"
			},
			{
				LookupStoreId: 1036,
				StoreName: "PITT AND PARK STREET NSW - CLOSED"
			},
			{
				LookupStoreId: 1037,
				StoreName: "CASTLE TOWERS I NSW - CLOSED;"
			},
			{
				LookupStoreId: 1038,
				StoreName: "MYER I QLD - CLOSED"
			},
			{
				LookupStoreId: 1039,
				StoreName: "COLLEGE VIEW - CLOSED"
			},
			{
				LookupStoreId: 1040,
				StoreName: "COLLINS STREET - CLOSED"
			},
			{
				LookupStoreId: 1041,
				StoreName: "EARLVILLE QLD - CLOSED"
			},
			{
				LookupStoreId: 1042,
				StoreName: "EASTLAND VIC - CLOSED"
			},
			{
				LookupStoreId: 1043,
				StoreName: "INALA QLD - CLOSED"
			},
			{
				LookupStoreId: 1044,
				StoreName: "NOWRA NSW - CLOSED"
			},
			{
				LookupStoreId: 1045,
				StoreName: "CRANBOURNE VIC - CLOSED"
			},
			{
				LookupStoreId: 1046,
				StoreName: "FELIXSTOWE SA - CLOSED"
			},
			{
				LookupStoreId: 1047,
				StoreName: "GLENELG SA - CLOSED"
			},
			{
				LookupStoreId: 1048,
				StoreName: "MASTERS SPRINGFIELD QLD - CLOSED"
			},
			{
				LookupStoreId: 1049,
				StoreName: "MARION FOOD COURT SA - CLOSED"
			},
			{
				LookupStoreId: 1050,
				StoreName: "MARTIN PLACE NSW - CLOSED"
			},
			{
				LookupStoreId: 1051,
				StoreName: "GLENORCHY TAS - CLOSED"
			},
			{
				LookupStoreId: 1052,
				StoreName: "ROSELANDS SHOPPING CENTRE NSW - CLOSED"
			},
			{
				LookupStoreId: 1053,
				StoreName: "SHEPPARTON CITY VIC - CLOSED"
			},
			{
				LookupStoreId: 1054,
				StoreName: "CAMPERDOWN NSW - CLOSED"
			},
			{
				LookupStoreId: 1055,
				StoreName: "CAPALABA PARK QLD - CLOSED"
			},
			{
				LookupStoreId: 1056,
				StoreName: "MARION FOOD COURT SA - CLOSED"
			},
			{
				LookupStoreId: 1057,
				StoreName: "CHATSWOOD WESTFIELD FOOD COURT NSW - CLOSED"
			},
			{
				LookupStoreId: 1058,
				StoreName: "SWANSTON STREET VIC - CLOSED"
			},
			{
				LookupStoreId: 1059,
				StoreName: "PARRAMATTA W/F L5 NSW - CLOSED"
			},
			{
				LookupStoreId: 1060,
				StoreName: "PARRAMATTA W/F L3 NSW - CLOSED"
			}
		];

		lookupStore.set(lookupTypes);
	};

	return {
		...lookupStore,
		getStores
	};
}

export default lookupService(null);
